// App-owned English messages with Finnish, Russian and Ukrainian translations.
import { reportingMessages } from "./reporting-translations";
export const messages = {
  ...reportingMessages,
  "Reorderable widget": [
    "Järjestettävä osio",
    "Перемещаемый виджет",
    "Переміщуваний віджет",
  ],
  "Synthetic TEHO extension:": [
    "Synteettinen TEHO-laajennus:",
    "Синтетическое расширение TEHO:",
    "Синтетичне розширення TEHO:",
  ],
  Dashboards: ["Koontinäytöt", "Панели", "Панелі"],
  Reports: ["Raportit", "Отчёты", "Звіти"],
  "Report Builder": [
    "Raportin rakentaja",
    "Конструктор отчётов",
    "Конструктор звітів",
  ],
  Analytics: ["Analytiikka", "Аналитика", "Аналітика"],
  "Management workspace": [
    "Hallinnan työtila",
    "Рабочее пространство управления",
    "Робочий простір керування",
  ],
  "North Coast Operating Unit": [
    "North Coast -toimintayksikkö",
    "Подразделение North Coast",
    "Операційний підрозділ North Coast",
  ],
  "North Coast · Management workspace": [
    "North Coast · Hallinnan työtila",
    "North Coast · Управление",
    "North Coast · Керування",
  ],
  "Luuta Operations Manager": [
    "Luuta-toimintapäällikkö",
    "Операционный менеджер Luuta",
    "Операційний менеджер Luuta",
  ],
  "Data snapshot": ["Tietojen tilannekuva", "Снимок данных", "Знімок даних"],
  "Operating data": [
    "Toiminnan tiedot",
    "Операционные данные",
    "Операційні дані",
  ],
  "Operations & dispatch": [
    "Toiminta ja työnjako",
    "Операции и диспетчеризация",
    "Операції та диспетчеризація",
  ],
  Preview: ["Esikatselu", "Предпросмотр", "Попередній перегляд"],
  "My work": ["Oma työ", "Моя работа", "Моя робота"],
  "Profile & performance": [
    "Profiili ja suoriutuminen",
    "Профиль и результаты",
    "Профіль і результати",
  ],
  "Cleaning guidance": [
    "Siivousohjeet",
    "Инструкции по уборке",
    "Інструкції з прибирання",
  ],
  "Support number": ["Tukinumero", "Телефон поддержки", "Телефон підтримки"],
  Administration: ["Hallinto", "Администрирование", "Адміністрування"],
  Organization: ["Organisaatio", "Организация", "Організація"],
  Locations: ["Kohteet", "Объекты", "Об’єкти"],
  "Work rules": ["Työsäännöt", "Правила работы", "Правила роботи"],
  Supplies: ["Tarvikkeet", "Расходные материалы", "Витратні матеріали"],
  Integrations: ["Integraatiot", "Интеграции", "Інтеграції"],
  "Workspace settings": [
    "Työtilan asetukset",
    "Настройки рабочего пространства",
    "Налаштування робочого простору",
  ],
  "Available in the full Luuta workspace": [
    "Saatavilla Luutan täydessä työtilassa",
    "Доступно в полной версии Luuta",
    "Доступно в повній версії Luuta",
  ],
  "Search features": ["Hae toimintoja", "Поиск функций", "Пошук функцій"],
  "Search features…": ["Hae toimintoja…", "Поиск функций…", "Пошук функцій…"],
  "No matching features": [
    "Vastaavia toimintoja ei löytynyt",
    "Подходящие функции не найдены",
    "Відповідних функцій не знайдено",
  ],
  "Interface language": [
    "Käyttöliittymän kieli",
    "Язык интерфейса",
    "Мова інтерфейсу",
  ],
  Light: ["Vaalea", "Светлая тема", "Світла тема"],
  "Main navigation": [
    "Päänavigointi",
    "Основная навигация",
    "Основна навігація",
  ],
  "Open navigation": [
    "Avaa navigointi",
    "Открыть навигацию",
    "Відкрити навігацію",
  ],
  "Close navigation": [
    "Sulje navigointi",
    "Закрыть навигацию",
    "Закрити навігацію",
  ],
  Breadcrumb: [
    "Navigointipolku",
    "Навигационная цепочка",
    "Навігаційний ланцюжок",
  ],
  "Manage your Luuta Analytics workspace.": [
    "Hallitse Luuta Analytics -työtilaasi.",
    "Управляйте рабочим пространством Luuta Analytics.",
    "Керуйте робочим простором Luuta Analytics.",
  ],
  "Operating Unit": [
    "Toimintayksikkö",
    "Подразделение",
    "Операційний підрозділ",
  ],
  "Available history": [
    "Saatavilla oleva historia",
    "Доступная история",
    "Доступна історія",
  ],
  "90 days · 3 properties": [
    "90 päivää · 3 kiinteistöä",
    "90 дней · 3 объекта",
    "90 днів · 3 об’єкти",
  ],
  "The metric definitions can be reviewed from the dashboard.": [
    "Mittarien määritelmät voi tarkistaa koontinäytöltä.",
    "Определения показателей доступны на панели.",
    "Визначення показників доступні на панелі.",
  ],
  "Restore default reports": [
    "Palauta oletusraportit",
    "Восстановить исходные отчёты",
    "Відновити початкові звіти",
  ],
  "Skip to main content": [
    "Siirry pääsisältöön",
    "Перейти к основному содержимому",
    "Перейти до основного вмісту",
  ],
  "Dismiss notification": [
    "Sulje ilmoitus",
    "Закрыть уведомление",
    "Закрити сповіщення",
  ],
  "Close dialog": ["Sulje valintaikkuna", "Закрыть окно", "Закрити вікно"],
  "Unable to save changes. Please try again.": [
    "Muutoksia ei voitu tallentaa. Yritä uudelleen.",
    "Не удалось сохранить изменения. Попробуйте ещё раз.",
    "Не вдалося зберегти зміни. Спробуйте ще раз.",
  ],
  "Default reports and settings restored.": [
    "Oletusraportit ja asetukset palautettu.",
    "Исходные отчёты и настройки восстановлены.",
    "Початкові звіти та налаштування відновлено.",
  ],
  "Results refreshed.": [
    "Tulokset päivitetty.",
    "Результаты обновлены.",
    "Результати оновлено.",
  ],
  "Untitled dashboard": [
    "Nimetön koontinäyttö",
    "Панель без названия",
    "Панель без назви",
  ],
  "Your saved reports in one view.": [
    "Tallennetut raporttisi yhdessä näkymässä.",
    "Ваши сохранённые отчёты в одном представлении.",
    "Ваші збережені звіти в одному поданні.",
  ],
  "Your saved operational reports, together in one view.": [
    "Tallennetut toimintaraporttisi yhdessä näkymässä.",
    "Ваши сохранённые операционные отчёты в одном представлении.",
    "Ваші збережені операційні звіти в одному поданні.",
  ],
  "Dashboard created. Add your first report widget.": [
    "Koontinäyttö luotu. Lisää ensimmäinen raporttiosio.",
    "Панель создана. Добавьте первый виджет отчёта.",
    "Панель створено. Додайте перший віджет звіту.",
  ],
  "Report saved.": [
    "Raportti tallennettu.",
    "Отчёт сохранён.",
    "Звіт збережено.",
  ],
  "Report duplicated.": [
    "Raportti kopioitu.",
    "Копия отчёта создана.",
    "Копію звіту створено.",
  ],
  "Report removed from the library and dashboards.": [
    "Raportti poistettu kirjastosta ja koontinäytöiltä.",
    "Отчёт удалён из библиотеки и панелей.",
    "Звіт видалено з бібліотеки та панелей.",
  ],
  "Opening report builder…": [
    "Avataan raportin rakentajaa…",
    "Открывается конструктор отчётов…",
    "Відкривається конструктор звітів…",
  ],
  "Opening data model…": [
    "Avataan tietomallia…",
    "Открывается модель данных…",
    "Відкривається модель даних…",
  ],
  "Dashboard layout": [
    "Koontinäyttöjen asettelu",
    "Вид панелей",
    "Вигляд панелей",
  ],
  "Report layout": ["Raporttien asettelu", "Вид отчётов", "Вигляд звітів"],
  "Card view": ["Korttinäkymä", "Карточки", "Картки"],
  "Table view": ["Taulukkonäkymä", "Таблица", "Таблиця"],
  Dashboard: ["Koontinäyttö", "Панель", "Панель"],
  "Your dashboards": ["Omat koontinäytöt", "Ваши панели", "Ваші панелі"],
  "Explore example dashboards or open your saved views.": [
    "Tutustu esimerkkikoontinäyttöihin tai avaa tallennetut näkymät.",
    "Изучите примеры панелей или откройте сохранённые представления.",
    "Перегляньте приклади панелей або відкрийте збережені подання.",
  ],
  "New dashboard": ["Uusi koontinäyttö", "Новая панель", "Нова панель"],
  "Dashboards table": [
    "Koontinäyttöjen taulukko",
    "Таблица панелей",
    "Таблиця панелей",
  ],
  "Dashboards and their descriptions": [
    "Koontinäytöt ja niiden kuvaukset",
    "Панели и их описания",
    "Панелі та їхні описи",
  ],
  Description: ["Kuvaus", "Описание", "Опис"],
  "Open dashboard": ["Avaa koontinäyttö", "Открыть панель", "Відкрити панель"],
  View: ["Näytä", "Открыть", "Відкрити"],
  "Example dashboard": [
    "Esimerkkikoontinäyttö",
    "Пример панели",
    "Приклад панелі",
  ],
  "Saved dashboard": [
    "Tallennettu koontinäyttö",
    "Сохранённая панель",
    "Збережена панель",
  ],
  "Done editing": [
    "Valmis",
    "Завершить редактирование",
    "Завершити редагування",
  ],
  "Edit dashboard": [
    "Muokkaa koontinäyttöä",
    "Изменить панель",
    "Редагувати панель",
  ],
  "Add report": ["Lisää raportti", "Добавить отчёт", "Додати звіт"],
  "Dashboard name": ["Koontinäytön nimi", "Название панели", "Назва панелі"],
  "Dashboard description": [
    "Koontinäytön kuvaus",
    "Описание панели",
    "Опис панелі",
  ],
  "New dashboard name": [
    "Uuden koontinäytön nimi",
    "Название новой панели",
    "Назва нової панелі",
  ],
  "Create dashboard": ["Luo koontinäyttö", "Создать панель", "Створити панель"],
  "Add a saved report to start this dashboard.": [
    "Aloita lisäämällä tallennettu raportti koontinäyttöön.",
    "Добавьте сохранённый отчёт, чтобы начать работу с панелью.",
    "Додайте збережений звіт, щоб почати роботу з панеллю.",
  ],
  "Add a report widget": [
    "Lisää raporttiosio",
    "Добавить виджет отчёта",
    "Додати віджет звіту",
  ],
  "Choose a saved report for this dashboard.": [
    "Valitse tallennettu raportti tähän koontinäyttöön.",
    "Выберите сохранённый отчёт для этой панели.",
    "Виберіть збережений звіт для цієї панелі.",
  ],
  "Drag to reorder, or press Space and use the arrow keys": [
    "Muuta järjestystä vetämällä tai paina välilyöntiä ja käytä nuolinäppäimiä",
    "Перетащите для изменения порядка или нажмите пробел и используйте стрелки",
    "Перетягніть для зміни порядку або натисніть пробіл і використовуйте стрілки",
  ],
  Report: ["Raportti", "Отчёт", "Звіт"],
  "No tags": ["Ei tunnisteita", "Нет тегов", "Немає тегів"],
  Author: ["Tekijä", "Автор", "Автор"],
  "All authors": ["Kaikki tekijät", "Все авторы", "Усі автори"],
  Presentation: ["Esitystapa", "Представление", "Подання"],
  "All presentations": [
    "Kaikki esitystavat",
    "Все представления",
    "Усі подання",
  ],
  "Authoring mode": ["Luontitapa", "Режим создания", "Режим створення"],
  "All modes": ["Kaikki tilat", "Все режимы", "Усі режими"],
  Guided: ["Ohjattu", "С подсказками", "З підказками"],
  "Source query": ["Malloy-kysely", "Запрос Malloy", "Запит Malloy"],
  Origin: ["Alkuperä", "Источник", "Походження"],
  "All origins": ["Kaikki alkuperät", "Все источники", "Усі джерела"],
  Templates: ["Mallit", "Шаблоны", "Шаблони"],
  Template: ["Malli", "Шаблон", "Шаблон"],
  "Saved reports": [
    "Tallennetut raportit",
    "Сохранённые отчёты",
    "Збережені звіти",
  ],
  "Saved report": [
    "Tallennettu raportti",
    "Сохранённый отчёт",
    "Збережений звіт",
  ],
  "Create report": ["Luo raportti", "Создать отчёт", "Створити звіт"],
  "Report filters": [
    "Raporttien suodattimet",
    "Фильтры отчётов",
    "Фільтри звітів",
  ],
  "Report name": ["Raportin nimi", "Название отчёта", "Назва звіту"],
  "Search by name…": ["Hae nimellä…", "Поиск по названию…", "Пошук за назвою…"],
  Tags: ["Tunnisteet", "Теги", "Теги"],
  "· Match any selected tag": [
    "· Vastaa mitä tahansa valittua tunnistetta",
    "· Любой из выбранных тегов",
    "· Будь-який із вибраних тегів",
  ],
  "Add tags in Report Builder to organize your reports.": [
    "Järjestä raporttisi lisäämällä tunnisteita raportin rakentajassa.",
    "Добавляйте теги в конструкторе для организации отчётов.",
    "Додавайте теги в конструкторі для впорядкування звітів.",
  ],
  "Active report filters": [
    "Aktiiviset raporttisuodattimet",
    "Активные фильтры отчётов",
    "Активні фільтри звітів",
  ],
  "Clear all": ["Tyhjennä kaikki", "Очистить всё", "Очистити все"],
  "Clear filters": [
    "Tyhjennä suodattimet",
    "Сбросить фильтры",
    "Скинути фільтри",
  ],
  "No matching reports": [
    "Vastaavia raportteja ei löytynyt",
    "Подходящие отчёты не найдены",
    "Відповідних звітів не знайдено",
  ],
  "No reports yet": [
    "Ei vielä raportteja",
    "Отчётов пока нет",
    "Звітів поки немає",
  ],
  "Try different filters to find a report.": [
    "Etsi raporttia eri suodattimilla.",
    "Попробуйте другие фильтры для поиска отчёта.",
    "Спробуйте інші фільтри для пошуку звіту.",
  ],
  "Create your first reusable report.": [
    "Luo ensimmäinen uudelleenkäytettävä raporttisi.",
    "Создайте первый многоразовый отчёт.",
    "Створіть перший багаторазовий звіт.",
  ],
  "Saved reports table": [
    "Tallennettujen raporttien taulukko",
    "Таблица сохранённых отчётов",
    "Таблиця збережених звітів",
  ],
  "Saved reports and their metadata": [
    "Tallennetut raportit ja niiden metatiedot",
    "Сохранённые отчёты и их метаданные",
    "Збережені звіти та їхні метадані",
  ],
  "Presentation / mode": [
    "Esitystapa / tila",
    "Представление / режим",
    "Подання / режим",
  ],
  Actions: ["Toiminnot", "Действия", "Дії"],
  "Duplicate report": [
    "Kopioi raportti",
    "Создать копию отчёта",
    "Створити копію звіту",
  ],
  "Edit report": ["Muokkaa raporttia", "Изменить отчёт", "Редагувати звіт"],
  "Delete report": ["Poista raportti", "Удалить отчёт", "Видалити звіт"],
  "Report details": [
    "Raportin tiedot",
    "Сведения об отчёте",
    "Відомості про звіт",
  ],
  "Give your report a name, description and tags to make it easy to find.": [
    "Anna raportille nimi, kuvaus ja tunnisteet, jotta se löytyy helposti.",
    "Укажите название, описание и теги для удобного поиска отчёта.",
    "Укажіть назву, опис і теги для зручного пошуку звіту.",
  ],
  "Report tags": ["Raportin tunnisteet", "Теги отчёта", "Теги звіту"],
  "Add a tag…": ["Lisää tunniste…", "Добавить тег…", "Додати тег…"],
  Add: ["Lisää", "Добавить", "Додати"],
  "Press Enter or click Add to create a tag.": [
    "Luo tunniste painamalla Enter tai napsauttamalla Lisää.",
    "Нажмите Enter или «Добавить», чтобы создать тег.",
    "Натисніть Enter або «Додати», щоб створити тег.",
  ],
  Cancel: ["Peruuta", "Отмена", "Скасувати"],
  "Apply changes": [
    "Käytä muutoksia",
    "Применить изменения",
    "Застосувати зміни",
  ],
  "Data model": ["Tietomalli", "Модель данных", "Модель даних"],
  "Back to Report Builder": [
    "Takaisin raportin rakentajaan",
    "Назад в конструктор отчётов",
    "Назад до конструктора звітів",
  ],
  "Explore sources, fields and measures alongside their model definitions.": [
    "Tutustu lähteisiin, kenttiin ja mittareihin sekä niiden mallimääritelmiin.",
    "Изучите источники, поля и показатели вместе с их определениями в модели.",
    "Перегляньте джерела, поля та показники разом із їхніми визначеннями в моделі.",
  ],
  "Retry initialization": [
    "Yritä alustusta uudelleen",
    "Повторить инициализацию",
    "Повторити ініціалізацію",
  ],
  "Loading the Luuta data model…": [
    "Ladataan Luutan tietomallia…",
    "Загрузка модели данных Luuta…",
    "Завантаження моделі даних Luuta…",
  ],
  "Loading the Luuta data model and analytics engine…": [
    "Ladataan Luutan tietomallia ja analytiikkamoottoria…",
    "Загрузка модели данных и аналитического движка Luuta…",
    "Завантаження моделі даних та аналітичного рушія Luuta…",
  ],
  "Explore the data model": [
    "Tutustu tietomalliin",
    "Изучить модель данных",
    "Переглянути модель даних",
  ],
  "Model definition": [
    "Mallin määritelmä",
    "Определение модели",
    "Визначення моделі",
  ],
  "Shared model · Read only": [
    "Yhteinen malli · Vain luku",
    "Общая модель · Только чтение",
    "Спільна модель · Лише читання",
  ],
  "Model definition code": [
    "Mallin määrittelykoodi",
    "Код определения модели",
    "Код визначення моделі",
  ],
  "Grain:": ["Tietorivin taso:", "Детализация:", "Деталізація:"],
  "Business source": [
    "Liiketoiminnan tietolähde",
    "Источник бизнес-данных",
    "Джерело бізнес-даних",
  ],
  Values: ["Arvot", "Значения", "Значення"],
  "Group by": ["Ryhmittely", "Группировка", "Групування"],
  "· select multiple": [
    "· valitse useita",
    "· можно выбрать несколько",
    "· можна вибрати кілька",
  ],
  "Search fields…": ["Hae kenttiä…", "Поиск полей…", "Пошук полів…"],
  "No matching fields.": [
    "Vastaavia kenttiä ei löytynyt.",
    "Подходящие поля не найдены.",
    "Відповідних полів не знайдено.",
  ],
  "Date grouping": [
    "Päivämäärän ryhmittely",
    "Группировка по дате",
    "Групування за датою",
  ],
  Filters: ["Suodattimet", "Фильтры", "Фільтри"],
  "Filter expression": [
    "Suodatinlauseke",
    "Выражение фильтра",
    "Вираз фільтра",
  ],
  "Filter values: a name for text, ≥ as >= for numbers, true/false for flags, or 2026-09 for a date.":
    [
      "Suodatinarvot: nimi tekstille, >= luvuille, true/false totuusarvoille tai 2026-09 päivämäärälle.",
      "Значения фильтра: имя для текста, >= для чисел, true/false для флагов или 2026-09 для даты.",
      "Значення фільтра: ім’я для тексту, >= для чисел, true/false для прапорців або 2026-09 для дати.",
    ],
  "Add filter": ["Lisää suodatin", "Добавить фильтр", "Додати фільтр"],
  "Order by": ["Järjestä kentän mukaan", "Сортировать по", "Сортувати за"],
  "Order direction": [
    "Järjestyssuunta",
    "Направление сортировки",
    "Напрямок сортування",
  ],
  "Automatic (dates in order)": [
    "Automaattinen (päivämääräjärjestys)",
    "Автоматически (даты по порядку)",
    "Автоматично (дати за порядком)",
  ],
  Ascending: ["Nouseva", "По возрастанию", "За зростанням"],
  Descending: ["Laskeva", "По убыванию", "За спаданням"],
  "Row limit": [
    "Rivien enimmäismäärä",
    "Ограничение строк",
    "Обмеження рядків",
  ],
  "Preview report": [
    "Esikatsele raporttia",
    "Просмотреть отчёт",
    "Переглянути звіт",
  ],
  "Save report": ["Tallenna raportti", "Сохранить отчёт", "Зберегти звіт"],
  "Write a query over the shared Luuta model. Use Ctrl+Space for sources, fields and metrics.":
    [
      "Kirjoita kysely Luutan yhteiseen malliin. Näytä lähteet, kentät ja mittarit painamalla Ctrl+välilyönti.",
      "Напишите запрос к общей модели Luuta. Нажмите Ctrl+Space для выбора источников, полей и показателей.",
      "Напишіть запит до спільної моделі Luuta. Натисніть Ctrl+Space для вибору джерел, полів і показників.",
    ],
  "Restore guided draft": [
    "Palauta ohjattu luonnos",
    "Восстановить черновик с подсказками",
    "Відновити чернетку з підказками",
  ],
  "Source query example": [
    "Malloy-kyselyn esimerkki",
    "Пример запроса Malloy",
    "Приклад запиту Malloy",
  ],
  "Insert an example…": [
    "Lisää esimerkki…",
    "Вставить пример…",
    "Вставити приклад…",
  ],
  "Tasks by property": [
    "Tehtävät kiinteistöittäin",
    "Задачи по объектам",
    "Завдання за об’єктами",
  ],
  "Nested task detail": [
    "Sisäkkäiset tehtävätiedot",
    "Вложенные сведения о задачах",
    "Вкладені відомості про завдання",
  ],
  "Result panel": ["Tulospaneeli", "Панель результатов", "Панель результатів"],
  "Report preview": [
    "Raportin esikatselu",
    "Предпросмотр отчёта",
    "Попередній перегляд звіту",
  ],
  "Source data": ["Lähdetiedot", "Исходные данные", "Вихідні дані"],
  "Preview source": [
    "Esikatselun lähde",
    "Источник предпросмотра",
    "Джерело попереднього перегляду",
  ],
  "Display as": ["Esitystapa", "Отображать как", "Відображати як"],
  "Settings changed. Preview the report to refresh these results.": [
    "Asetukset muuttuivat. Päivitä tulokset esikatselemalla raporttia.",
    "Настройки изменены. Обновите результаты через предпросмотр отчёта.",
    "Налаштування змінено. Оновіть результати через попередній перегляд звіту.",
  ],
  "Choose values, then preview the report.": [
    "Valitse arvot ja esikatsele raporttia.",
    "Выберите значения и откройте предпросмотр отчёта.",
    "Виберіть значення та відкрийте попередній перегляд звіту.",
  ],
  "Generated source query": [
    "Luotu Malloy-kysely",
    "Сформированный запрос Malloy",
    "Сформований запит Malloy",
  ],
  "Presentation settings": [
    "Esitystavan asetukset",
    "Настройки представления",
    "Налаштування подання",
  ],
  "Restore guided draft?": [
    "Palautetaanko ohjattu luonnos?",
    "Восстановить черновик с подсказками?",
    "Відновити чернетку з підказками?",
  ],
  "This replaces your source query edits with the guided configuration saved when you switched modes.":
    [
      "Tämä korvaa kyselymuutokset ohjatuilla asetuksilla, jotka tallennettiin tilaa vaihdettaessa.",
      "Изменения запроса будут заменены настройками, сохранёнными при переключении режима.",
      "Зміни запиту буде замінено налаштуваннями, збереженими під час перемикання режиму.",
    ],
  "Keep source query edits": [
    "Säilytä kyselymuutokset",
    "Сохранить изменения запроса",
    "Зберегти зміни запиту",
  ],
  "Source query editor": [
    "Malloy-kyselyeditori",
    "Редактор запросов Malloy",
    "Редактор запитів Malloy",
  ],
  "Preparing your results…": [
    "Valmistellaan tuloksia…",
    "Подготовка результатов…",
    "Підготовка результатів…",
  ],
  "No results for this selection": [
    "Tällä valinnalla ei ole tuloksia",
    "Нет результатов для выбранных условий",
    "Немає результатів для вибраних умов",
  ],
  "Try a different property, period or report filter.": [
    "Kokeile toista kiinteistöä, ajanjaksoa tai raporttisuodatinta.",
    "Попробуйте другой объект, период или фильтр отчёта.",
    "Спробуйте інший об’єкт, період або фільтр звіту.",
  ],
  "Not available": ["Ei saatavilla", "Нет данных", "Немає даних"],
  Yes: ["Kyllä", "Да", "Так"],
  No: ["Ei", "Нет", "Ні"],
  Ready: ["Valmis", "Готово", "Готово"],
  Blocked: ["Estynyt", "Заблокировано", "Заблоковано"],
  Inspection: ["Tarkastus", "Проверка", "Перевірка"],
  "Dashboard filters": [
    "Koontinäytön suodattimet",
    "Фильтры панели",
    "Фільтри панелі",
  ],
  Property: ["Kiinteistö", "Объект", "Об’єкт"],
  "Property filter": [
    "Kiinteistösuodatin",
    "Фильтр объектов",
    "Фільтр об’єктів",
  ],
  "All properties": ["Kaikki kiinteistöt", "Все объекты", "Усі об’єкти"],
  "Reporting period": ["Raportointijakso", "Отчётный период", "Звітний період"],
  Today: ["Tänään", "Сегодня", "Сьогодні"],
  "Last 7 days": ["Viimeiset 7 päivää", "Последние 7 дней", "Останні 7 днів"],
  "Last 30 days": [
    "Viimeiset 30 päivää",
    "Последние 30 дней",
    "Останні 30 днів",
  ],
  "Last 90 days": [
    "Viimeiset 90 päivää",
    "Последние 90 дней",
    "Останні 90 днів",
  ],
  "Custom dates": ["Mukautetut päivämäärät", "Другие даты", "Інші дати"],
  From: ["Alkaen", "С", "Від"],
  To: ["Asti", "По", "До"],
  "Apply dates": ["Käytä päivämääriä", "Применить даты", "Застосувати дати"],
  "The start date must be before the end date.": [
    "Alkupäivän on oltava ennen loppupäivää.",
    "Начальная дата должна предшествовать конечной.",
    "Початкова дата має передувати кінцевій.",
  ],
  Refresh: ["Päivitä", "Обновить", "Оновити"],
  "Refresh results": [
    "Päivitä tulokset",
    "Обновить результаты",
    "Оновити результати",
  ],
  "Report rows": ["Raportin rivit", "Строки отчёта", "Рядки звіту"],
  "Table pagination": [
    "Taulukon sivutus",
    "Страницы таблицы",
    "Сторінки таблиці",
  ],
  Previous: ["Edellinen", "Назад", "Назад"],
  Next: ["Seuraava", "Далее", "Далі"],
  "Export CSV": ["Vie CSV", "Экспорт CSV", "Експорт CSV"],
  "Check widget configuration": [
    "Tarkista osion asetukset",
    "Проверьте настройки виджета",
    "Перевірте налаштування віджета",
  ],
  "Choose your chart fields": [
    "Valitse kaavion kentät",
    "Выберите поля диаграммы",
    "Виберіть поля діаграми",
  ],
  "Select an X-axis field and numeric value from the query results, or use a table.":
    [
      "Valitse kyselyn tuloksista X-akselin kenttä ja numeerinen arvo tai käytä taulukkoa.",
      "Выберите поле оси X и числовое значение из результатов или используйте таблицу.",
      "Виберіть поле осі X і числове значення з результатів або використовуйте таблицю.",
    ],
  "No recorded time in this selection": [
    "Tälle valinnalle ei ole kirjattua aikaa",
    "Нет учтённого времени для выбранных условий",
    "Немає облікованого часу для вибраних умов",
  ],
  "Close full-screen report": [
    "Sulje koko näytön raportti",
    "Закрыть полноэкранный отчёт",
    "Закрити повноекранний звіт",
  ],
  "Retry report": [
    "Yritä raporttia uudelleen",
    "Повторить отчёт",
    "Повторити звіт",
  ],
  "Saved query ·": [
    "Tallennettu kysely ·",
    "Сохранённый запрос ·",
    "Збережений запит ·",
  ],
  "Configure widget": [
    "Määritä osio",
    "Настроить виджет",
    "Налаштувати віджет",
  ],
  "Changes apply only to this widget. Save to keep them.": [
    "Muutokset koskevat vain tätä osiota. Säilytä ne tallentamalla.",
    "Изменения относятся только к этому виджету. Сохраните их.",
    "Зміни стосуються лише цього віджета. Збережіть їх.",
  ],
  "Widget title": ["Osion otsikko", "Заголовок виджета", "Заголовок віджета"],
  "Widget description": ["Osion kuvaus", "Описание виджета", "Опис віджета"],
  "Widget width": ["Osion leveys", "Ширина виджета", "Ширина віджета"],
  Width: ["Leveys", "Ширина", "Ширина"],
  "One fifth": ["Viidesosa", "Одна пятая", "Одна п’ята"],
  "One third": ["Kolmasosa", "Одна треть", "Одна третина"],
  Half: ["Puolet", "Половина", "Половина"],
  "Full width": ["Täysi leveys", "Полная ширина", "Повна ширина"],
  "Live preview": [
    "Reaaliaikainen esikatselu",
    "Предпросмотр в реальном времени",
    "Попередній перегляд у реальному часі",
  ],
  "Reset to report defaults": [
    "Palauta raportin oletukset",
    "Сбросить к настройкам отчёта",
    "Скинути до налаштувань звіту",
  ],
  "Save widget": ["Tallenna osio", "Сохранить виджет", "Зберегти віджет"],
  Visualization: ["Visualisointi", "Визуализация", "Візуалізація"],
  "Widget visualization": [
    "Osion visualisointi",
    "Визуализация виджета",
    "Візуалізація віджета",
  ],
  Table: ["Taulukko", "Таблица", "Таблиця"],
  Bar: ["Pylväs", "Столбчатая", "Стовпчаста"],
  Line: ["Viiva", "Линейная", "Лінійна"],
  Pie: ["Ympyrä", "Круговая", "Кругова"],
  "Card details": ["Kortin tiedot", "Сведения карточки", "Відомості картки"],
  "Show heading": [
    "Näytä otsikko",
    "Показывать заголовок",
    "Показувати заголовок",
  ],
  "Show description": [
    "Näytä kuvaus",
    "Показывать описание",
    "Показувати опис",
  ],
  "Show query footer": [
    "Näytä kyselyn alatunniste",
    "Показывать сведения о запросе",
    "Показувати відомості про запит",
  ],
  "X-axis": ["X-akseli", "Ось X", "Вісь X"],
  "Widget X-axis": ["Osion X-akseli", "Ось X виджета", "Вісь X віджета"],
  "Choose field": ["Valitse kenttä", "Выберите поле", "Виберіть поле"],
  "KPI value": ["KPI-arvo", "Значение KPI", "Значення KPI"],
  "KPI appearance": ["KPI-ulkoasu", "Вид KPI", "Вигляд KPI"],
  Preset: ["Esiasetus", "Стиль", "Стиль"],
  "KPI preset": ["KPI-esiasetus", "Стиль KPI", "Стиль KPI"],
  "Choose preset": ["Valitse esiasetus", "Выберите стиль", "Виберіть стиль"],
  Neutral: ["Neutraali", "Нейтральный", "Нейтральний"],
  "Highlighted teal": [
    "Korostettu turkoosi",
    "Бирюзовый акцент",
    "Бірюзовий акцент",
  ],
  Alignment: ["Tasaus", "Выравнивание", "Вирівнювання"],
  "KPI alignment": ["KPI-tasaus", "Выравнивание KPI", "Вирівнювання KPI"],
  Start: ["Alku", "По началу", "На початку"],
  Center: ["Keskellä", "По центру", "По центру"],
  End: ["Loppu", "По концу", "У кінці"],
  "Label placement": [
    "Otsikon sijainti",
    "Расположение подписи",
    "Розташування підпису",
  ],
  "KPI label placement": [
    "KPI-otsikon sijainti",
    "Расположение подписи KPI",
    "Розташування підпису KPI",
  ],
  "Above value": ["Arvon yläpuolella", "Над значением", "Над значенням"],
  "Below value": ["Arvon alapuolella", "Под значением", "Під значенням"],
  "Value size": ["Arvon koko", "Размер значения", "Розмір значення"],
  "KPI value size": [
    "KPI-arvon koko",
    "Размер значения KPI",
    "Розмір значення KPI",
  ],
  Small: ["Pieni", "Маленький", "Малий"],
  Medium: ["Keskikokoinen", "Средний", "Середній"],
  Large: ["Suuri", "Большой", "Великий"],
  "Surface color": ["Taustaväri", "Цвет фона", "Колір тла"],
  "Border color": ["Reunaväri", "Цвет рамки", "Колір рамки"],
  "Value color": ["Arvon väri", "Цвет значения", "Колір значення"],
  "Target line (optional)": [
    "Tavoiteviiva (valinnainen)",
    "Целевая линия (необязательно)",
    "Цільова лінія (необов’язково)",
  ],
  "Widget target": ["Osion tavoite", "Цель виджета", "Ціль віджета"],
  "Visible columns and order": [
    "Näkyvät sarakkeet ja järjestys",
    "Видимые столбцы и порядок",
    "Видимі стовпці та порядок",
  ],
  "Field labels and formats": [
    "Kenttien nimet ja muotoilut",
    "Подписи и форматы полей",
    "Підписи та формати полів",
  ],
  "Number format": ["Lukumuoto", "Формат числа", "Формат числа"],
  Number: ["Luku", "Число", "Число"],
  Currency: ["Valuutta", "Валюта", "Валюта"],
  Percent: ["Prosentti", "Процент", "Відсоток"],
  Ratio: ["Suhde", "Доля", "Частка"],
  Minutes: ["Minuutit", "Минуты", "Хвилини"],
  Hours: ["Tunnit", "Часы", "Години"],
  "Series colors": ["Sarjojen värit", "Цвета рядов", "Кольори рядів"],
  "Slice colors": ["Sektorien värit", "Цвета секторов", "Кольори секторів"],
  "Cleaning task investigation": [
    "Siivoustehtävän tarkastelu",
    "Разбор задачи по уборке",
    "Розбір завдання з прибирання",
  ],
  "Cleaning task": [
    "Siivoustehtävä",
    "Задача по уборке",
    "Завдання з прибирання",
  ],
  "This task is outside the selected cohort.": [
    "Tämä tehtävä ei kuulu valittuun joukkoon.",
    "Эта задача не входит в выбранную выборку.",
    "Це завдання не входить до вибраної вибірки.",
  ],
  "Employee sessions": [
    "Työntekijöiden työjaksot",
    "Сессии сотрудников",
    "Сесії працівників",
  ],
  "Inspection evidence": [
    "Tarkastuksen tiedot",
    "Данные проверки",
    "Дані перевірки",
  ],
  "Supply orders": [
    "Tarviketilaukset",
    "Заказы материалов",
    "Замовлення матеріалів",
  ],
  "Build a supply-order report": [
    "Luo tarviketilausraportti",
    "Создать отчёт по заказам материалов",
    "Створити звіт за замовленнями матеріалів",
  ],
  "Luuta — Analytics": [
    "Luuta — Analytiikka",
    "Luuta — Аналитика",
    "Luuta — Аналітика",
  ],
  "Luuta Analytics — operational clarity, from readiness to the records behind every result.":
    [
      "Luuta Analytics — toiminnan selkeys, valmiudesta jokaisen tuloksen taustatietoihin.",
      "Luuta Analytics — прозрачность операций: от готовности до записей, стоящих за каждым результатом.",
      "Luuta Analytics — прозорість операцій: від готовності до записів, що стоять за кожним результатом.",
    ],
  "Cleaning completion": [
    "Siivousten valmistuminen",
    "Завершение уборки",
    "Завершення прибирання",
  ],
  "Recorded completion evidence and task deadlines.": [
    "Kirjatut valmistumistiedot ja tehtävien määräajat.",
    "Зафиксированное завершение и сроки задач.",
    "Зафіксоване завершення та строки завдань.",
  ],
  "Units currently clean": [
    "Tällä hetkellä puhtaat yksiköt",
    "Сейчас чистые помещения",
    "Зараз чисті приміщення",
  ],
  "Current active-unit snapshot. Historical period filters do not apply.": [
    "Aktiivisten yksiköiden nykytilanne. Historiallisen ajanjakson suodattimet eivät vaikuta.",
    "Текущий снимок активных помещений. Фильтры исторического периода не применяются.",
    "Поточний знімок активних приміщень. Фільтри історичного періоду не застосовуються.",
  ],
  "Completion by deadline": [
    "Valmistuminen määräajassa",
    "Завершение в срок",
    "Завершення вчасно",
  ],
  "Non-cancelled due tasks, including overdue incomplete work.": [
    "Erääntyneet peruuttamattomat tehtävät, myös myöhässä olevat keskeneräiset työt.",
    "Задачи с наступившим сроком без отменённых, включая просроченные незавершённые.",
    "Завдання зі строком, що настав, без скасованих, включно з простроченими незавершеними.",
  ],
  "Completion by property": [
    "Valmistuminen kiinteistöittäin",
    "Завершение по объектам",
    "Завершення за об’єктами",
  ],
  "Task completion against each recorded deadline.": [
    "Tehtävien valmistuminen suhteessa kirjattuihin määräaikoihin.",
    "Завершение задач относительно их зафиксированных сроков.",
    "Завершення завдань відносно їхніх зафіксованих строків.",
  ],
  "Current unit states": [
    "Yksiköiden nykytilat",
    "Текущие состояния помещений",
    "Поточні стани приміщень",
  ],
  "Active units at the fixed snapshot, regardless of selected historical period.":
    [
      "Aktiiviset yksiköt kiinteässä tilannekuvassa valitusta historiallisesta ajanjaksosta riippumatta.",
      "Активные помещения на фиксированный момент независимо от выбранного исторического периода.",
      "Активні приміщення на фіксований момент незалежно від вибраного історичного періоду.",
    ],
  "Recorded session effort": [
    "Kirjattu työjaksoaika",
    "Учтённые трудозатраты сессий",
    "Обліковані трудовитрати сесій",
  ],
  "Closed per-person session spans, including breaks.": [
    "Päättyneet henkilökohtaiset työjaksot taukoineen.",
    "Закрытые сессии каждого сотрудника, включая перерывы.",
    "Закриті сесії кожного працівника, включно з перервами.",
  ],
  "Effort by unit type": [
    "Työaika yksikkötyypeittäin",
    "Трудозатраты по типу помещения",
    "Трудовитрати за типом приміщення",
  ],
  "Recorded person-hours by current unit classification.": [
    "Kirjatut henkilötyötunnit yksiköiden nykyisen luokituksen mukaan.",
    "Учтённые человеко-часы по текущей классификации помещений.",
    "Обліковані людино-години за поточною класифікацією приміщень.",
  ],
  "Employee session effort": [
    "Työntekijöiden työjaksoaika",
    "Трудозатраты сотрудников по сессиям",
    "Трудовитрати працівників за сесіями",
  ],
  "Session time belongs to each employee; task quality remains task-level.": [
    "Työjaksoaika kuuluu kullekin työntekijälle; tehtävän laatu pysyy tehtävätasolla.",
    "Время сессии относится к сотруднику; качество остаётся на уровне задачи.",
    "Час сесії належить працівнику; якість залишається на рівні завдання.",
  ],
  "First-inspection quality": [
    "Ensitarkastuksen laatu",
    "Качество первой проверки",
    "Якість першої перевірки",
  ],
  "Earliest linked result; a later pass preserves the first failure.": [
    "Varhaisin liitetty tulos; myöhempi hyväksyntä ei poista ensimmäistä hylkäystä.",
    "Первый связанный результат; последующий успех не отменяет первую неудачу.",
    "Перший пов’язаний результат; подальший успіх не скасовує першої невдачі.",
  ],
  "Inspection coverage": [
    "Tarkastusten kattavuus",
    "Охват проверками",
    "Охоплення перевірками",
  ],
  "Non-cancelled tasks with submitted linked inspections.": [
    "Peruuttamattomat tehtävät, joihin liittyy lähetetty tarkastus.",
    "Неотменённые задачи со сданными связанными проверками.",
    "Нескасовані завдання зі зданими пов’язаними перевірками.",
  ],
  "Actual break time": [
    "Todellinen taukoaika",
    "Фактическое время перерывов",
    "Фактичний час перерв",
  ],
  "Observed break intervals, not duration entitlements.": [
    "Havaitut taukovälit, ei tauko-oikeuksien kestoja.",
    "Наблюдаемые интервалы перерывов, а не положенная длительность.",
    "Спостережувані інтервали перерв, а не належна тривалість.",
  ],
  "Supply-order context": [
    "Tarviketilausten tilanne",
    "Контекст заказов материалов",
    "Контекст замовлень матеріалів",
  ],
  "Submitted-order age is elapsed order age, not cleaner waiting labor.": [
    "Lähetetyn tilauksen ikä on tilauksesta kulunut aika, ei siivoojan odotustyöaika.",
    "Возраст отправленного заказа — прошедшее время, а не ожидание уборщика.",
    "Вік надісланого замовлення — час, що минув, а не очікування прибиральника.",
  ],
  "Timestamp diagnostics": [
    "Aikaleimojen diagnostiikka",
    "Диагностика временных меток",
    "Діагностика часових позначок",
  ],
  "Open sessions and missing/invalid timestamp evidence.": [
    "Avoimet työjaksot sekä puuttuvat tai virheelliset aikaleimat.",
    "Открытые сессии и отсутствующие или некорректные временные метки.",
    "Відкриті сесії та відсутні або некоректні часові позначки.",
  ],
  "Task status detail": [
    "Tehtävien tilatiedot",
    "Подробные статусы задач",
    "Докладні статуси завдань",
  ],
  "A nested source query report. Expand each property to inspect task states.":
    [
      "Sisäkkäinen Malloy-kyselyraportti. Avaa kiinteistö nähdäksesi tehtävien tilat.",
      "Вложенный отчёт Malloy. Разверните объект для просмотра статусов задач.",
      "Вкладений звіт Malloy. Розгорніть об’єкт для перегляду статусів завдань.",
    ],
  "Cleaner TEHO": ["Siivoojan TEHO", "TEHO уборщика", "TEHO прибиральника"],
  "Driver TEHO": ["Kuljettajan TEHO", "TEHO водителя", "TEHO водія"],
  "Cleaner TEHO · contribution": [
    "Siivoojan TEHO · kate",
    "TEHO уборщика · маржинальный доход",
    "TEHO прибиральника · маржинальний дохід",
  ],
  "Cleaning revenue": [
    "Siivoustulot",
    "Доход от уборки",
    "Дохід від прибирання",
  ],
  "Full-shift wages": [
    "Koko työvuoron palkat",
    "Оплата полной смены",
    "Оплата повної зміни",
  ],
  "Contribution margin": [
    "Kateprosentti",
    "Доля маржинального дохода",
    "Частка маржинального доходу",
  ],
  "Revenue per paid hour": [
    "Tulot palkallista tuntia kohti",
    "Доход на оплаченный час",
    "Дохід на оплачену годину",
  ],
  "Paid hours": ["Palkalliset tunnit", "Оплаченные часы", "Оплачені години"],
  "Driver TEHO · illustrative / 100": [
    "Kuljettajan TEHO · havainnollistava / 100",
    "TEHO водителя · пример / 100",
    "TEHO водія · приклад / 100",
  ],
  "Completed deliveries": [
    "Valmistuneet toimitukset",
    "Выполненные доставки",
    "Виконані доставки",
  ],
  "Physical trips": ["Fyysiset ajot", "Физические поездки", "Фізичні поїздки"],
  "SLA compliance": [
    "SLA-vaatimusten täyttyminen",
    "Соблюдение SLA",
    "Дотримання SLA",
  ],
  "Urgent on-time handling": [
    "Kiireellisten käsittely ajoissa",
    "Срочные заявки вовремя",
    "Термінові заявки вчасно",
  ],
  "Route efficiency": [
    "Reittitehokkuus",
    "Эффективность маршрута",
    "Ефективність маршруту",
  ],
  "Repeat trips": ["Uusinta-ajot", "Повторные поездки", "Повторні поїздки"],
  "Dog/help share of completed deliveries": [
    "Koira- ja lisäaputoimitusten osuus valmistuneista",
    "Доля доставок с собаками/помощью",
    "Частка доставок із собаками/допомогою",
  ],
  "Cleaner waiting (person-minutes)": [
    "Siivoojien odotus (henkilöminuutteina)",
    "Ожидание уборщиков (человеко-минуты)",
    "Очікування прибиральників (людино-хвилини)",
  ],
  "Daily revenue, wages and contribution": [
    "Päivittäiset tulot, palkat ja kate",
    "Доход, оплата и маржинальный доход по дням",
    "Дохід, оплата та маржинальний дохід за днями",
  ],
  "Contribution by cleaner": [
    "Kate siivoojittain",
    "Маржинальный доход по уборщикам",
    "Маржинальний дохід за прибиральниками",
  ],
  "Payroll coverage · lunch excluded, coffee included": [
    "Palkkatietojen kattavuus · lounas pois, kahvitauot mukana",
    "Охват оплатой · без обеда, с кофе-перерывами",
    "Охоплення оплатою · без обіду, з кавовими перервами",
  ],
  "Shift and task detail · first 100 shifts; up to 100 tasks each": [
    "Työvuoro- ja tehtävätiedot · 100 ensimmäistä vuoroa; enintään 100 tehtävää kussakin",
    "Смены и задачи · первые 100 смен; до 100 задач в каждой",
    "Зміни та завдання · перші 100 змін; до 100 завдань у кожній",
  ],
  "Daily Driver TEHO": [
    "Kuljettajan päivittäinen TEHO",
    "TEHO водителя по дням",
    "TEHO водія за днями",
  ],
  "Completed deliveries by driver": [
    "Valmistuneet toimitukset kuljettajittain",
    "Выполненные доставки по водителям",
    "Виконані доставки за водіями",
  ],
  "Score components · 2 credits/hour target; 10 waiting person-minutes/request budget":
    [
      "Pisteiden osat · tavoite 2 pistettä/tunti; odotusbudjetti 10 henkilöminuuttia/pyyntö",
      "Компоненты оценки · цель 2 кредита/час; бюджет ожидания 10 человеко-минут/заявку",
      "Компоненти оцінки · ціль 2 кредити/годину; бюджет очікування 10 людино-хвилин/заявку",
    ],
  "Effective weights · N/A redistributes": [
    "Todelliset painot · puuttuvat jaetaan uudelleen",
    "Фактические веса · нет данных — перераспределение",
    "Фактичні ваги · немає даних — перерозподіл",
  ],
  "Driver comparison": [
    "Kuljettajavertailu",
    "Сравнение водителей",
    "Порівняння водіїв",
  ],
  "Delivery and trip detail · first 100 requests; up to 100 trips each": [
    "Toimitus- ja ajotiedot · 100 ensimmäistä pyyntöä; enintään 100 ajoa kussakin",
    "Доставки и поездки · первые 100 заявок; до 100 поездок в каждой",
    "Доставки та поїздки · перші 100 заявок; до 100 поїздок у кожній",
  ],
  "Selected properties and reporting period": [
    "Valitut kiinteistöt ja raportointijakso",
    "Выбранные объекты и отчётный период",
    "Вибрані об’єкти та звітний період",
  ],
  "Illustrative cleaning revenue minus full-shift direct wages, before overhead. Lunch excluded; coffee included.":
    [
      "Havainnollistavat siivoustulot vähennettynä koko vuoron suorilla palkoilla ennen yleiskuluja. Lounas pois, kahvitauot mukana.",
      "Пример: доход от уборки минус прямая оплата полной смены, до накладных расходов. Без обеда, с кофе-перерывами.",
      "Приклад: дохід від прибирання мінус пряма оплата повної зміни, до накладних витрат. Без обіду, з кавовими перервами.",
    ],
  "Illustrative driver score with deliveries, repeat trips, SLA, dog/help work, urgent handling, routes and cleaner waiting.":
    [
      "Havainnollistava kuljettajapisteytys: toimitukset, uusinta-ajot, SLA, koira- ja lisäaputyö, kiireellisyys, reitit ja siivoojien odotus.",
      "Пример оценки водителя: доставки, повторные поездки, SLA, собаки/помощь, срочность, маршруты и ожидание уборщиков.",
      "Приклад оцінки водія: доставки, повторні поїздки, SLA, собаки/допомога, терміновість, маршрути й очікування прибиральників.",
    ],
  "Operations overview": [
    "Toiminnan yleiskuva",
    "Обзор операций",
    "Огляд операцій",
  ],
  "Task completion, current unit state, inspection quality and supply context.":
    [
      "Tehtävien valmistuminen, yksiköiden nykytila, tarkastusten laatu ja tarviketilanne.",
      "Завершение задач, текущее состояние помещений, качество проверок и материалы.",
      "Завершення завдань, поточний стан приміщень, якість перевірок і матеріали.",
    ],
  "Effort & quality": [
    "Työaika ja laatu",
    "Трудозатраты и качество",
    "Трудовитрати та якість",
  ],
  "Recorded employee-session effort with task-level quality and timestamp diagnostics.":
    [
      "Kirjattu työntekijöiden työjaksoaika, tehtävätason laatu ja aikaleimojen diagnostiikka.",
      "Учтённые сессии сотрудников, качество задач и диагностика временных меток.",
      "Обліковані сесії працівників, якість завдань і діагностика часових позначок.",
    ],
  "Cleaning tasks by property": [
    "Siivoustehtävät kiinteistöittäin",
    "Задачи по уборке по объектам",
    "Завдання з прибирання за об’єктами",
  ],
  "Reusable task-cohort report.": [
    "Uudelleenkäytettävä tehtäväjoukon raportti.",
    "Многоразовый отчёт по выборке задач.",
    "Багаторазовий звіт за вибіркою завдань.",
  ],
  copy: ["kopio", "копия", "копія"],
  "Cleaning tasks": [
    "Siivoustehtävät",
    "Задачи по уборке",
    "Завдання з прибирання",
  ],
  "Cleaner sessions": [
    "Siivoojien työjaksot",
    "Сессии уборщиков",
    "Сесії прибиральників",
  ],
  Inspections: ["Tarkastukset", "Проверки", "Перевірки"],
  "Current units": [
    "Nykyiset yksiköt",
    "Текущие помещения",
    "Поточні приміщення",
  ],
  "Cleaner TEHO shifts": [
    "Siivoojien TEHO-työvuorot",
    "Смены уборщиков TEHO",
    "Зміни прибиральників TEHO",
  ],
  "Driver TEHO shifts": [
    "Kuljettajien TEHO-työvuorot",
    "Смены водителей TEHO",
    "Зміни водіїв TEHO",
  ],
  "TEHO cleaning prices": [
    "TEHO-siivoushinnat",
    "Цены уборки TEHO",
    "Ціни прибирання TEHO",
  ],
  "TEHO task revenue allocations": [
    "TEHO-tehtävätulojen kohdistukset",
    "Распределение дохода задач TEHO",
    "Розподіл доходу завдань TEHO",
  ],
  "Driver delivery requests": [
    "Kuljettajien toimituspyynnöt",
    "Заявки на доставку водителям",
    "Заявки на доставку водіям",
  ],
  "Driver physical trips": [
    "Kuljettajien fyysiset ajot",
    "Физические поездки водителей",
    "Фізичні поїздки водіїв",
  ],
  "Cleaner waiting intervals": [
    "Siivoojien odotusvälit",
    "Интервалы ожидания уборщиков",
    "Інтервали очікування прибиральників",
  ],
  "Reusable measure defined in the Luuta data model.": [
    "Luutan tietomallissa määritelty uudelleenkäytettävä mittari.",
    "Многоразовый показатель модели данных Luuta.",
    "Багаторазовий показник моделі даних Luuta.",
  ],
  "Luuta data model:": [
    "Luutan tietomalli:",
    "Модель данных Luuta:",
    "Модель даних Luuta:",
  ],
  Task: ["Tehtävä", "Задача", "Завдання"],
  Shift: ["Työvuoro", "Смена", "Зміна"],
  Cleaner: ["Siivooja", "Уборщик", "Прибиральник"],
  Driver: ["Kuljettaja", "Водитель", "Водій"],
  House: ["Talo", "Дом", "Будинок"],
  Request: ["Pyyntö", "Заявка", "Заявка"],
  "Work date": ["Työpäivä", "Рабочая дата", "Робоча дата"],
  "Shift start": ["Työvuoron alku", "Начало смены", "Початок зміни"],
  "Hourly wage (€)": [
    "Tuntipalkka (€)",
    "Почасовая ставка (€)",
    "Погодинна ставка (€)",
  ],
  "Lunch excluded (minutes)": [
    "Pois jätetty lounas (minuuttia)",
    "Исключённый обед (минуты)",
    "Виключений обід (хвилини)",
  ],
  "Coffee included (minutes)": [
    "Mukana olevat kahvitauot (minuuttia)",
    "Включённые кофе-перерывы (минуты)",
    "Включені кавові перерви (хвилини)",
  ],
  "Paid task minutes": [
    "Palkalliset tehtäväminuutit",
    "Оплаченные минуты задач",
    "Оплачені хвилини завдань",
  ],
  "Allocated revenue": [
    "Kohdistetut tulot",
    "Распределённый доход",
    "Розподілений дохід",
  ],
  "Eligible closed shifts": [
    "Kelvolliset päättyneet vuorot",
    "Учтённые закрытые смены",
    "Враховані закриті зміни",
  ],
  "Excluded/open shifts": [
    "Pois jätetyt / avoimet vuorot",
    "Исключённые/открытые смены",
    "Виключені/відкриті зміни",
  ],
  "Excluded shifts": [
    "Pois jätetyt vuorot",
    "Исключённые смены",
    "Виключені зміни",
  ],
  "Shifts with missing evidence": [
    "Vuorot, joista puuttuu tietoja",
    "Смены с неполными данными",
    "Зміни з неповними даними",
  ],
  "Evidence coverage": [
    "Tietojen kattavuus",
    "Полнота данных",
    "Повнота даних",
  ],
  "Delivery requests": [
    "Toimituspyynnöt",
    "Заявки на доставку",
    "Заявки на доставку",
  ],
  "Deliveries due": [
    "Erääntyneet toimitukset",
    "Доставки с наступившим сроком",
    "Доставки зі строком, що настав",
  ],
  "On-time deliveries": [
    "Ajoissa tehdyt toimitukset",
    "Доставки вовремя",
    "Доставки вчасно",
  ],
  "Urgent deliveries due": [
    "Erääntyneet kiireelliset toimitukset",
    "Срочные доставки с наступившим сроком",
    "Термінові доставки зі строком, що настав",
  ],
  "Urgent deliveries on time": [
    "Kiireelliset toimitukset ajoissa",
    "Срочные доставки вовремя",
    "Термінові доставки вчасно",
  ],
  "Dog/help": ["Koira / lisäapu", "Собаки/помощь", "Собаки/допомога"],
  "Dog/help deliveries": [
    "Koira- ja lisäaputoimitukset",
    "Доставки с собаками/помощью",
    "Доставки із собаками/допомогою",
  ],
  "Workload credits (dog/help ×1.5)": [
    "Työmääräpisteet (koira/lisäapu ×1,5)",
    "Кредиты нагрузки (собаки/помощь ×1,5)",
    "Кредити навантаження (собаки/допомога ×1,5)",
  ],
  "Trip kilometres": [
    "Ajokilometrit",
    "Километры поездок",
    "Кілометри поїздок",
  ],
  "Waiting per request (person-minutes)": [
    "Odotus pyyntöä kohti (henkilöminuuttia)",
    "Ожидание на заявку (человеко-минуты)",
    "Очікування на заявку (людино-хвилини)",
  ],
  "Requests with missing evidence": [
    "Pyynnöt, joista puuttuu tietoja",
    "Заявки с неполными данными",
    "Заявки з неповними даними",
  ],
  "Productivity component": [
    "Tuottavuusosatekijä",
    "Компонент производительности",
    "Компонент продуктивності",
  ],
  "Repeat-trip component": [
    "Uusinta-ajojen osatekijä",
    "Компонент повторных поездок",
    "Компонент повторних поїздок",
  ],
  "Route component": [
    "Reittiosatekijä",
    "Компонент маршрута",
    "Компонент маршруту",
  ],
  "Waiting component": [
    "Odotusosatekijä",
    "Компонент ожидания",
    "Компонент очікування",
  ],
  "Productivity weight": [
    "Tuottavuuden paino",
    "Вес производительности",
    "Вага продуктивності",
  ],
  "Repeat-trip weight": [
    "Uusinta-ajojen paino",
    "Вес повторных поездок",
    "Вага повторних поїздок",
  ],
  "SLA weight": ["SLA-paino", "Вес SLA", "Вага SLA"],
  "Urgent weight": [
    "Kiireellisyyden paino",
    "Вес срочности",
    "Вага терміновості",
  ],
  "Route weight": ["Reitin paino", "Вес маршрута", "Вага маршруту"],
  "Waiting weight": ["Odotuksen paino", "Вес ожидания", "Вага очікування"],
  "Created (UTC)": ["Luotu (UTC)", "Создано (UTC)", "Створено (UTC)"],
  "Completed (UTC)": ["Valmis (UTC)", "Завершено (UTC)", "Завершено (UTC)"],
  "SLA deadline (UTC)": [
    "SLA-määräaika (UTC)",
    "Срок SLA (UTC)",
    "Строк SLA (UTC)",
  ],
  Urgent: ["Kiireellinen", "Срочно", "Терміново"],
  "Earliest linked result": [
    "Varhaisin liitetty tulos",
    "Первый связанный результат",
    "Перший пов’язаний результат",
  ],
  "Invalid break intervals": [
    "Virheelliset taukovälit",
    "Некорректные интервалы перерывов",
    "Некоректні інтервали перерв",
  ],
  "Observed span through as-of including open sessions": [
    "Havaittu aikaväli tilannekuvaan asti, myös avoimet työjaksot",
    "Наблюдаемый интервал до снимка, включая открытые сессии",
    "Спостережуваний інтервал до знімка, включно з відкритими сесіями",
  ],
  "Completed cleaning revenue minus full-shift direct wages. Illustrative; excludes overhead and employer costs.":
    [
      "Valmistuneiden siivousten tulot vähennettynä koko vuoron suorilla palkoilla. Havainnollistava; ei yleis- eikä työnantajakuluja.",
      "Доход от завершённой уборки минус прямая оплата полной смены. Пример; без накладных расходов и затрат работодателя.",
      "Дохід від завершеного прибирання мінус пряма оплата повної зміни. Приклад; без накладних витрат і витрат роботодавця.",
    ],
  "Illustrative contribution after full-shift direct wages; lunch excluded, coffee included.":
    [
      "Havainnollistava kate koko vuoron suorien palkkojen jälkeen; lounas pois, kahvitauot mukana.",
      "Пример маржинального дохода после оплаты полной смены; без обеда, с кофе-перерывами.",
      "Приклад маржинального доходу після оплати повної зміни; без обіду, з кавовими перервами.",
    ],
  "Illustrative 0–100 workload-adjusted score; all weights and evidence are visible.":
    [
      "Havainnollistava työmäärään suhteutettu pistemäärä 0–100; kaikki painot ja tiedot näkyvät.",
      "Пример оценки 0–100 с учётом нагрузки; все веса и данные видны.",
      "Приклад оцінки 0–100 з урахуванням навантаження; усі ваги й дані видимі.",
    ],
  "Illustrative weights: productivity 20%, repeats 15%, SLA 25%, urgent 15%, route 15%, waiting 10%. N/A components redistribute weights.":
    [
      "Esimerkkipainot: tuottavuus 20 %, uusinnat 15 %, SLA 25 %, kiireellisyys 15 %, reitti 15 %, odotus 10 %. Puuttuvat osat jakavat painot uudelleen.",
      "Веса примера: производительность 20%, повторы 15%, SLA 25%, срочность 15%, маршрут 15%, ожидание 10%. При отсутствии данных веса перераспределяются.",
      "Ваги прикладу: продуктивність 20%, повтори 15%, SLA 25%, терміновість 15%, маршрут 15%, очікування 10%. За відсутності даних ваги перерозподіляються.",
    ],
  "Effective weights · base: productivity 20%, repeats 15%, SLA 25%, urgent 15%, route 15%, waiting 10%; N/A redistributes":
    [
      "Todelliset painot · pohja: tuottavuus 20 %, uusinnat 15 %, SLA 25 %, kiireellisyys 15 %, reitti 15 %, odotus 10 %; puuttuvat jaetaan uudelleen",
      "Фактические веса · база: производительность 20%, повторы 15%, SLA 25%, срочность 15%, маршрут 15%, ожидание 10%; нет данных — перераспределение",
      "Фактичні ваги · база: продуктивність 20%, повтори 15%, SLA 25%, терміновість 15%, маршрут 15%, очікування 10%; немає даних — перерозподіл",
    ],
  "Operating Unit identity": [
    "Toimintayksikön tunniste",
    "Идентификатор подразделения",
    "Ідентифікатор підрозділу",
  ],
  "Property identity": [
    "Kiinteistön tunniste",
    "Идентификатор объекта",
    "Ідентифікатор об’єкта",
  ],
  "Current property display name": [
    "Kiinteistön nykyinen näyttönimi",
    "Текущее отображаемое имя объекта",
    "Поточне відображуване ім’я об’єкта",
  ],
  "Property unit identity": [
    "Kiinteistöyksikön tunniste",
    "Идентификатор помещения объекта",
    "Ідентифікатор приміщення об’єкта",
  ],
  "Property unit display name": [
    "Kiinteistöyksikön näyttönimi",
    "Отображаемое имя помещения",
    "Відображуване ім’я приміщення",
  ],
  "Current unit classification": [
    "Yksikön nykyinen luokitus",
    "Текущая классификация помещения",
    "Поточна класифікація приміщення",
  ],
  "Fixed as-of timestamp in UTC": [
    "Kiinteä tilannekuvan aikaleima UTC-ajassa",
    "Фиксированная временная метка снимка в UTC",
    "Фіксована часова позначка знімка в UTC",
  ],
  "Task-cohort date; unlinked records use their own event date": [
    "Tehtäväjoukon päivämäärä; liittämättömät tietueet käyttävät omaa tapahtumapäiväänsä",
    "Дата выборки задач; несвязанные записи используют дату своего события",
    "Дата вибірки завдань; непов’язані записи використовують дату своєї події",
  ],
  "Task identity": [
    "Tehtävän tunniste",
    "Идентификатор задачи",
    "Ідентифікатор завдання",
  ],
  "Task state at snapshot": [
    "Tehtävän tila tilannekuvassa",
    "Статус задачи на момент снимка",
    "Статус завдання на момент знімка",
  ],
  "Actual task start": [
    "Tehtävän todellinen alku",
    "Фактическое начало задачи",
    "Фактичний початок завдання",
  ],
  "Recorded server completion": [
    "Palvelimelle kirjattu valmistuminen",
    "Завершение, зафиксированное сервером",
    "Завершення, зафіксоване сервером",
  ],
  "Task deadline": ["Tehtävän määräaika", "Срок задачи", "Строк завдання"],
  "Distinct employees with a session": [
    "Eri työntekijät, joilla on työjakso",
    "Уникальные сотрудники с сессией",
    "Унікальні працівники із сесією",
  ],
  "Session participant names": [
    "Työjakson osallistujien nimet",
    "Имена участников сессии",
    "Імена учасників сесії",
  ],
  "Sum of closed per-person spans, including breaks": [
    "Päättyneiden henkilökohtaisten aikavälien summa taukoineen",
    "Сумма закрытых интервалов сотрудников с перерывами",
    "Сума закритих інтервалів працівників із перервами",
  ],
  "Union of observed intervals bounded to sessions and as-of": [
    "Havaittujen aikavälien yhdiste rajattuna työjaksoihin ja tilannekuvaan",
    "Объединение наблюдаемых интервалов в границах сессий и снимка",
    "Об’єднання спостережуваних інтервалів у межах сесій і знімка",
  ],
  "Sessions with invalid timestamps": [
    "Työjaksot, joiden aikaleimat ovat virheellisiä",
    "Сессии с некорректными временными метками",
    "Сесії з некоректними часовими позначками",
  ],
  "Open sessions excluded from closed effort": [
    "Avoimet työjaksot jätetään päättyneen työajan ulkopuolelle",
    "Открытые сессии исключены из закрытых трудозатрат",
    "Відкриті сесії виключено із закритих трудовитрат",
  ],
  "Missing/invalid completion evidence": [
    "Puuttuvat tai virheelliset valmistumistiedot",
    "Отсутствующие или некорректные данные о завершении",
    "Відсутні або некоректні дані про завершення",
  ],
  "Completed with valid evidence by as-of": [
    "Valmis kelvollisten tietojen mukaan tilannekuvaan mennessä",
    "Завершено с корректными данными к моменту снимка",
    "Завершено з коректними даними до моменту знімка",
  ],
  "Non-cancelled task due by as-of": [
    "Peruuttamaton tehtävä, jonka määräaika on tilannekuvaan mennessä",
    "Неотменённая задача со сроком до момента снимка",
    "Нескасоване завдання зі строком до моменту знімка",
  ],
  "Due task completed by deadline": [
    "Erääntynyt tehtävä valmis määräajassa",
    "Задача завершена до срока",
    "Завдання завершено до строку",
  ],
  "Submitted linked result by as-of": [
    "Liitetty tulos lähetetty tilannekuvaan mennessä",
    "Связанный результат сдан к моменту снимка",
    "Пов’язаний результат здано до моменту знімка",
  ],
  "Earliest submitted linked result; timestamp then result ID": [
    "Varhaisin lähetetty liitetty tulos; ensin aikaleima, sitten tulostunniste",
    "Первый сданный связанный результат; сначала метка времени, затем ID результата",
    "Перший зданий пов’язаний результат; спочатку позначка часу, потім ID результату",
  ],
  "First outcome is CLEAN": [
    "Ensimmäinen tulos on CLEAN",
    "Первый результат — CLEAN",
    "Перший результат — CLEAN",
  ],
  "Linked submitted orders": [
    "Liitetyt lähetetyt tilaukset",
    "Связанные отправленные заказы",
    "Пов’язані надіслані замовлення",
  ],
  "Oldest submitted-order age, not cleaner waiting": [
    "Vanhimman lähetetyn tilauksen ikä, ei siivoojan odotus",
    "Возраст старейшего отправленного заказа, не ожидание уборщика",
    "Вік найстарішого надісланого замовлення, не очікування прибиральника",
  ],
  "Supply review state": [
    "Tarviketarkastuksen tila",
    "Статус проверки материалов",
    "Статус перевірки матеріалів",
  ],
  "Employee identity": [
    "Työntekijän tunniste",
    "Идентификатор сотрудника",
    "Ідентифікатор працівника",
  ],
  "Employee display name": [
    "Työntekijän näyttönimi",
    "Отображаемое имя сотрудника",
    "Відображуване ім’я працівника",
  ],
  "ShiftAssignment identity": [
    "ShiftAssignment-tunniste",
    "Идентификатор ShiftAssignment",
    "Ідентифікатор ShiftAssignment",
  ],
  "Session state": ["Työjakson tila", "Статус сессии", "Статус сесії"],
  "Session start": ["Työjakson alku", "Начало сессии", "Початок сесії"],
  "Session end by as-of": [
    "Työjakson loppu tilannekuvaan mennessä",
    "Конец сессии к моменту снимка",
    "Кінець сесії до моменту знімка",
  ],
  "No end evidence by as-of": [
    "Lopputieto puuttuu tilannekuvaan mennessä",
    "Нет данных об окончании к моменту снимка",
    "Немає даних про закінчення до моменту знімка",
  ],
  "Invalid timestamp evidence": [
    "Virheelliset aikaleimatiedot",
    "Некорректные временные метки",
    "Некоректні часові позначки",
  ],
  "Closed-session person-minutes including breaks": [
    "Päättyneiden työjaksojen henkilöminuutit taukoineen",
    "Человеко-минуты закрытых сессий с перерывами",
    "Людино-хвилини закритих сесій із перервами",
  ],
  "Observed coffee1/coffee2 intervals": [
    "Havaitut coffee1/coffee2-taukovälit",
    "Наблюдаемые интервалы coffee1/coffee2",
    "Спостережувані інтервали coffee1/coffee2",
  ],
  "Observed meal intervals": [
    "Havaitut ruokataukovälit",
    "Наблюдаемые интервалы обеда",
    "Спостережувані інтервали обіду",
  ],
  "Union of observed break intervals": [
    "Havaittujen taukovälien yhdiste",
    "Объединение наблюдаемых интервалов перерывов",
    "Об’єднання спостережуваних інтервалів перерв",
  ],
  "Result identity": [
    "Tuloksen tunniste",
    "Идентификатор результата",
    "Ідентифікатор результату",
  ],
  "Inspection task identity": [
    "Tarkastustehtävän tunniste",
    "Идентификатор задачи проверки",
    "Ідентифікатор завдання перевірки",
  ],
  "Reinspection lineage": [
    "Uusintatarkastuksen alkuperäketju",
    "Связь повторной проверки",
    "Зв’язок повторної перевірки",
  ],
  "Inspection state": [
    "Tarkastuksen tila",
    "Статус проверки",
    "Статус перевірки",
  ],
  "Submission by as-of": [
    "Lähetys tilannekuvaan mennessä",
    "Отправка к моменту снимка",
    "Надсилання до моменту знімка",
  ],
  "Raw rating without assumed scale": [
    "Alkuperäinen arvio ilman oletettua asteikkoa",
    "Исходная оценка без предположения о шкале",
    "Початкова оцінка без припущення про шкалу",
  ],
  "Cleaning-state outcome": [
    "Siivoustilan tulos",
    "Результат состояния уборки",
    "Результат стану прибирання",
  ],
  "Unit identity": [
    "Yksikön tunniste",
    "Идентификатор помещения",
    "Ідентифікатор приміщення",
  ],
  "Latest state change by as-of": [
    "Viimeisin tilamuutos tilannekuvaan mennessä",
    "Последнее изменение статуса к моменту снимка",
    "Остання зміна статусу до моменту знімка",
  ],
  "Order identity": [
    "Tilauksen tunniste",
    "Идентификатор заказа",
    "Ідентифікатор замовлення",
  ],
  "Optional cleaning task": [
    "Valinnainen siivoustehtävä",
    "Необязательная задача по уборке",
    "Необов’язкове завдання з прибирання",
  ],
  "Order priority": [
    "Tilauksen kiireellisyys",
    "Приоритет заказа",
    "Пріоритет замовлення",
  ],
  "Creation timestamp": [
    "Luonnin aikaleima",
    "Временная метка создания",
    "Часова позначка створення",
  ],
  "Submitted-order age only": [
    "Vain lähetetyn tilauksen ikä",
    "Только возраст отправленного заказа",
    "Лише вік надісланого замовлення",
  ],
  "Unique fact identity": [
    "Yksilöllinen tietuetunniste",
    "Уникальный идентификатор факта",
    "Унікальний ідентифікатор факту",
  ],
  "Single property owning the shift": [
    "Työvuoron omistava kiinteistö",
    "Единственный объект смены",
    "Єдиний об’єкт зміни",
  ],
  "Property display name": [
    "Kiinteistön näyttönimi",
    "Отображаемое имя объекта",
    "Відображуване ім’я об’єкта",
  ],
  "Owning shift's local work date": [
    "Omistavan vuoron paikallinen työpäivä",
    "Локальная рабочая дата смены",
    "Локальна робоча дата зміни",
  ],
  "Fixed evidence cutoff": [
    "Kiinteä tietojen katkaisuaika",
    "Фиксированная граница данных",
    "Фіксована межа даних",
  ],
  "One synthetic cleaner paid shift": [
    "Yksi synteettinen siivoojan palkallinen työvuoro",
    "Одна синтетическая оплаченная смена уборщика",
    "Одна синтетична оплачена зміна прибиральника",
  ],
  "One synthetic driver shift/route": [
    "Yksi synteettinen kuljettajan työvuoro/reitti",
    "Одна синтетическая смена/маршрут водителя",
    "Одна синтетична зміна/маршрут водія",
  ],
  "Closed shift end by snapshot": [
    "Päättyneen vuoron loppu tilannekuvaan mennessä",
    "Конец закрытой смены к моменту снимка",
    "Кінець закритої зміни до моменту знімка",
  ],
  "Hourly wage snapshot in EUR cents": [
    "Tuntipalkan tilannekuva eurosentteinä",
    "Снимок почасовой ставки в евроцентах",
    "Знімок погодинної ставки в євроцентах",
  ],
  "Closed full-shift elapsed minutes": [
    "Päättyneen koko vuoron kuluneet minuutit",
    "Прошедшие минуты полной закрытой смены",
    "Хвилини повної закритої зміни, що минули",
  ],
  "Union of lunch intervals bounded to shift": [
    "Työvuoroon rajattujen lounasvälien yhdiste",
    "Объединение интервалов обеда в границах смены",
    "Об’єднання інтервалів обіду в межах зміни",
  ],
  "Union of coffee intervals, included in pay": [
    "Palkkaan sisältyvien kahvitaukojen yhdiste",
    "Объединение оплачиваемых кофе-перерывов",
    "Об’єднання оплачуваних кавових перерв",
  ],
  "Valid closed shift at snapshot": [
    "Kelvollinen päättynyt vuoro tilannekuvassa",
    "Корректная закрытая смена на момент снимка",
    "Коректна закрита зміна на момент знімка",
  ],
  "Required evidence is complete and valid": [
    "Vaaditut tiedot ovat täydellisiä ja kelvollisia",
    "Обязательные данные полны и корректны",
    "Обов’язкові дані повні та коректні",
  ],
  "One synthetic priced cleaning task": [
    "Yksi synteettinen hinnoiteltu siivoustehtävä",
    "Одна синтетическая задача уборки с ценой",
    "Одне синтетичне завдання прибирання з ціною",
  ],
  "House/unit display name": [
    "Talon/yksikön näyttönimi",
    "Отображаемое имя дома/помещения",
    "Відображуване ім’я будинку/приміщення",
  ],
  "Task completed by snapshot": [
    "Tehtävä valmis tilannekuvaan mennessä",
    "Задача завершена к моменту снимка",
    "Завдання завершено до моменту знімка",
  ],
  "Immutable task price in EUR cents": [
    "Muuttumaton tehtävähinta eurosentteinä",
    "Неизменяемая цена задачи в евроцентах",
    "Незмінна ціна завдання в євроцентах",
  ],
  "Task price currency; requires EUR": [
    "Tehtävähinnan valuutta; vaatii EUR",
    "Валюта цены задачи; требуется EUR",
    "Валюта ціни завдання; потрібна EUR",
  ],
  "All participants' bounded task minutes less lunch": [
    "Kaikkien osallistujien rajatut tehtäväminuutit vähennettynä lounaalla",
    "Ограниченные минуты задачи всех участников за вычетом обеда",
    "Обмежені хвилини завдання всіх учасників за вирахуванням обіду",
  ],
  "One task/shift participant": [
    "Yksi tehtävän/työvuoron osallistuja",
    "Один участник задачи/смены",
    "Один учасник завдання/зміни",
  ],
  "Owning cleaner shift": [
    "Omistava siivoojan vuoro",
    "Смена уборщика",
    "Зміна прибиральника",
  ],
  "Priced cleaning task": [
    "Hinnoiteltu siivoustehtävä",
    "Задача уборки с ценой",
    "Завдання прибирання з ціною",
  ],
  "Closed participant task span": [
    "Osallistujan päättynyt tehtäväväli",
    "Закрытый интервал задачи участника",
    "Закритий інтервал завдання учасника",
  ],
  "Lunch overlapping the participant span": [
    "Osallistujan aikavälin kanssa päällekkäinen lounas",
    "Обед, пересекающийся с интервалом участника",
    "Обід, що перетинається з інтервалом учасника",
  ],
  "Cumulative paid task minutes before this participant in source order; supports conserving allocated cents":
    [
      "Kertyneet palkalliset tehtäväminuutit ennen osallistujaa lähdejärjestyksessä; säilyttää kohdistetut sentit",
      "Накопленные оплаченные минуты до этого участника в порядке источника; сохраняет распределённые центы",
      "Накопичені оплачені хвилини до цього учасника в порядку джерела; зберігає розподілені центи",
    ],
  "Participant, task price and full shift are eligible": [
    "Osallistuja, tehtävähinta ja koko vuoro ovat kelvollisia",
    "Участник, цена задачи и полная смена соответствуют условиям",
    "Учасник, ціна завдання й повна зміна відповідають умовам",
  ],
  "One delivery demand, regardless of trip count": [
    "Yksi toimituspyyntö ajomäärästä riippumatta",
    "Одна потребность в доставке независимо от числа поездок",
    "Одна потреба в доставці незалежно від кількості поїздок",
  ],
  "Owning driver shift": [
    "Omistava kuljettajan vuoro",
    "Смена водителя",
    "Зміна водія",
  ],
  "Request creation and SLA clock start": [
    "Pyynnön luonti ja SLA-ajan alku",
    "Создание заявки и начало отсчёта SLA",
    "Створення заявки й початок відліку SLA",
  ],
  "Explicit request SLA deadline": [
    "Pyynnön nimenomainen SLA-määräaika",
    "Явный срок SLA заявки",
    "Явний строк SLA заявки",
  ],
  "Delivery completion by snapshot": [
    "Toimituksen valmistuminen tilannekuvaan mennessä",
    "Завершение доставки к моменту снимка",
    "Завершення доставки до моменту знімка",
  ],
  "Urgent request": [
    "Kiireellinen pyyntö",
    "Срочная заявка",
    "Термінова заявка",
  ],
  "Combined dog/extra-assistance workload category": [
    "Yhdistetty koira- ja lisäaputyön luokka",
    "Объединённая категория нагрузки с собаками/дополнительной помощью",
    "Об’єднана категорія навантаження із собаками/додатковою допомогою",
  ],
  "Cancelled request excluded from delivery populations": [
    "Peruutettu pyyntö pois toimitusjoukoista",
    "Отменённая заявка исключена из выборок доставок",
    "Скасовану заявку виключено з вибірок доставок",
  ],
  "Non-cancelled request due by snapshot": [
    "Peruuttamaton pyyntö erääntynyt tilannekuvaan mennessä",
    "Неотменённая заявка со сроком до снимка",
    "Нескасована заявка зі строком до знімка",
  ],
  "Due delivery completed no later than deadline": [
    "Erääntynyt toimitus valmis viimeistään määräajassa",
    "Доставка завершена не позднее срока",
    "Доставку завершено не пізніше строку",
  ],
  "Completed non-cancelled delivery": [
    "Valmistunut peruuttamaton toimitus",
    "Завершённая неотменённая доставка",
    "Завершена нескасована доставка",
  ],
  "Deadline, wait observation and trip evidence are valid": [
    "Määräaika, odotushavainto ja ajotiedot ovat kelvollisia",
    "Срок, наблюдения ожидания и данные поездок корректны",
    "Строк, спостереження очікування й дані поїздок коректні",
  ],
  "One physical delivery attempt": [
    "Yksi fyysinen toimitusyritys",
    "Одна физическая попытка доставки",
    "Одна фізична спроба доставки",
  ],
  "Owning delivery request": [
    "Omistava toimituspyyntö",
    "Заявка на доставку",
    "Заявка на доставку",
  ],
  "Physical trip start": [
    "Fyysisen ajon alku",
    "Начало физической поездки",
    "Початок фізичної поїздки",
  ],
  "Physical trip end by snapshot": [
    "Fyysisen ajon loppu tilannekuvaan mennessä",
    "Конец физической поездки к моменту снимка",
    "Кінець фізичної поїздки до моменту знімка",
  ],
  "Observed trip kilometres": [
    "Havaitut ajokilometrit",
    "Наблюдаемые километры поездки",
    "Спостережувані кілометри поїздки",
  ],
  "Chronological physical attempt number for request": [
    "Pyynnön fyysisen yrityksen numero aikajärjestyksessä",
    "Хронологический номер физической попытки по заявке",
    "Хронологічний номер фізичної спроби за заявкою",
  ],
  "One disjoint attributed cleaner waiting interval": [
    "Yksi erillinen kohdistettu siivoojan odotusväli",
    "Один непересекающийся атрибутированный интервал ожидания уборщика",
    "Один неперетинний атрибутований інтервал очікування прибиральника",
  ],
  "Delivery causing the waiting": [
    "Odotuksen aiheuttava toimitus",
    "Доставка, вызвавшая ожидание",
    "Доставка, що спричинила очікування",
  ],
  "Waiting cleaner identity": [
    "Odottavan siivoojan tunniste",
    "Идентификатор ожидающего уборщика",
    "Ідентифікатор прибиральника, що очікує",
  ],
  "Bounded waiting start": [
    "Rajattu odotuksen alku",
    "Ограниченное начало ожидания",
    "Обмежений початок очікування",
  ],
  "Bounded waiting end": [
    "Rajattu odotuksen loppu",
    "Ограниченное окончание ожидания",
    "Обмежене закінчення очікування",
  ],
  "Waiting person-minutes, overlap merged per cleaner across requests and driver shifts":
    [
      "Odotuksen henkilöminuutit, päällekkäisyydet yhdistetty siivoojittain pyyntöjen ja kuljettajavuorojen yli",
      "Человеко-минуты ожидания с объединением пересечений по уборщику между заявками и сменами водителей",
      "Людино-хвилини очікування з об’єднанням перетинів за прибиральником між заявками й змінами водіїв",
    ],
  "Observed kilometres including repeated trips": [
    "Havaitut kilometrit uusinta-ajoineen",
    "Наблюдаемые километры с повторными поездками",
    "Спостережувані кілометри з повторними поїздками",
  ],
  "Planned kilometres for the same route population": [
    "Saman reittijoukon suunnitellut kilometrit",
    "Плановые километры той же выборки маршрутов",
    "Планові кілометри тієї самої вибірки маршрутів",
  ],
  "Available base weight / 100": [
    "Saatavilla oleva peruspaino / 100",
    "Доступный базовый вес / 100",
    "Доступна базова вага / 100",
  ],
  "One delivery demand; dog/help includes dogs and extra assistance.": [
    "Yksi toimituspyyntö; koira/lisäapu sisältää koirat ja lisäavun.",
    "Одна потребность в доставке; собаки/помощь включает собак и дополнительную помощь.",
    "Одна потреба в доставці; собаки/допомога включає собак і додаткову допомогу.",
  ],
  "One physical attempt; additional attempts are repeat trips.": [
    "Yksi fyysinen yritys; lisäyritykset ovat uusinta-ajoja.",
    "Одна физическая попытка; дополнительные попытки — повторные поездки.",
    "Одна фізична спроба; додаткові спроби — повторні поїздки.",
  ],
  "Explicit waiting person-minutes; overlapping intervals for the same cleaner are merged.":
    [
      "Nimenomaiset odotushenkilöminuutit; saman siivoojan päällekkäiset välit yhdistetään.",
      "Явные человеко-минуты ожидания; пересекающиеся интервалы одного уборщика объединяются.",
      "Явні людино-хвилини очікування; інтервали одного прибиральника, що перетинаються, об’єднуються.",
    ],
  "Synthetic immutable EUR house-cleaning prices; not production billing.": [
    "Synteettiset muuttumattomat talosiivouksen eurohinnat; ei tuotantolaskutusta.",
    "Синтетические неизменяемые цены уборки домов в EUR; не рабочая система оплаты.",
    "Синтетичні незмінні ціни прибирання будинків у EUR; не робоча система оплати.",
  ],
  "A house price is allocated by paid participant minutes, never copied to each cleaner.":
    [
      "Talon hinta jaetaan osallistujien palkallisten minuuttien mukaan, sitä ei kopioida jokaiselle siivoojalle.",
      "Цена дома распределяется по оплаченным минутам участников, а не копируется каждому уборщику.",
      "Ціна будинку розподіляється за оплаченими хвилинами учасників, а не копіюється кожному прибиральнику.",
    ],
  "Duplicate {p0}": [
    "Kopioi {p0}",
    "Создать копию: {p0}",
    "Створити копію: {p0}",
  ],
  "Edit {p0}": ["Muokkaa: {p0}", "Изменить: {p0}", "Редагувати: {p0}"],
  "Delete {p0}": ["Poista {p0}", "Удалить: {p0}", "Видалити: {p0}"],
  "Remove {p0}": ["Poista {p0}", "Убрать: {p0}", "Прибрати: {p0}"],
  "Remove {p0} filter": [
    "Poista suodatin {p0}",
    "Убрать фильтр «{p0}»",
    "Прибрати фільтр «{p0}»",
  ],
  "Remove tag {p0}": [
    "Poista tunniste {p0}",
    "Удалить тег «{p0}»",
    "Видалити тег «{p0}»",
  ],
  "Reorder {p0}": [
    "Järjestä {p0}",
    "Изменить порядок: {p0}",
    "Змінити порядок: {p0}",
  ],
  "Open {p0}": ["Avaa {p0}", "Открыть: {p0}", "Відкрити: {p0}"],
  "Move {p0} up": [
    "Siirrä {p0} ylös",
    "Переместить {p0} вверх",
    "Перемістити {p0} вгору",
  ],
  "Move {p0} down": [
    "Siirrä {p0} alas",
    "Переместить {p0} вниз",
    "Перемістити {p0} вниз",
  ],
  "Move column {p0} up": [
    "Siirrä sarake {p0} ylös",
    "Переместить столбец {p0} вверх",
    "Перемістити стовпець {p0} вгору",
  ],
  "Move column {p0} down": [
    "Siirrä sarake {p0} alas",
    "Переместить столбец {p0} вниз",
    "Перемістити стовпець {p0} вниз",
  ],
  "Label for {p0}": [
    "Kentän {p0} nimi",
    "Подпись поля {p0}",
    "Підпис поля {p0}",
  ],
  "Format for {p0}": [
    "Kentän {p0} muotoilu",
    "Формат поля {p0}",
    "Формат поля {p0}",
  ],
  "Color for {p0}": ["Kentän {p0} väri", "Цвет поля {p0}", "Колір поля {p0}"],
  "Search {p0} fields": [
    "Hae kenttiä: {p0}",
    "Поиск полей: {p0}",
    "Пошук полів: {p0}",
  ],
  "Name: {p0}": ["Nimi: {p0}", "Название: {p0}", "Назва: {p0}"],
  "Tag: {p0}": ["Tunniste: {p0}", "Тег: {p0}", "Тег: {p0}"],
  "Filter field {p0}": [
    "Suodatinkenttä {p0}",
    "Поле фильтра {p0}",
    "Поле фільтра {p0}",
  ],
  "Remove filter {p0}": [
    "Poista suodatin {p0}",
    "Удалить фильтр {p0}",
    "Видалити фільтр {p0}",
  ],
  "Filter expression {p0}": [
    "Suodatinlauseke {p0}",
    "Выражение фильтра {p0}",
    "Вираз фільтра {p0}",
  ],
  "Actions for {p0}": [
    "Raportin {p0} toiminnot",
    "Действия для {p0}",
    "Дії для {p0}",
  ],
  "Configure {p0}": ["Määritä {p0}", "Настроить {p0}", "Налаштувати {p0}"],
  "Edit query for {p0}": [
    "Muokkaa kyselyä: {p0}",
    "Изменить запрос: {p0}",
    "Редагувати запит: {p0}",
  ],
  "View {p0} full screen": [
    "Näytä {p0} koko näytössä",
    "Открыть {p0} на весь экран",
    "Відкрити {p0} на весь екран",
  ],
  "Export {p0}": ["Vie {p0}", "Экспортировать {p0}", "Експортувати {p0}"],
  "{shown} of {total}": [
    "{shown} / {total}",
    "{shown} / {total}",
    "{shown} / {total}",
  ],
  "{reports}. Find an answer, make it your own.": [
    "{reports}. Löydä vastaus ja muokkaa siitä omasi.",
    "{reports}. Найдите ответ и адаптируйте его.",
    "{reports}. Знайдіть відповідь і адаптуйте її.",
  ],
  "{from}–{to} of {rows}": [
    "{from}–{to} / {rows}",
    "{from}–{to} / {rows}",
    "{from}–{to} / {rows}",
  ],
  "· first 1,000 shown": [
    "· ensimmäiset 1 000 näytetään",
    "· показаны первые 1 000",
    "· показано перші 1 000",
  ],
  min: ["min", "мин", "хв"],
  h: ["h", "ч", "год"],
  ms: ["ms", "мс", "мс"],
  Day: ["Päivä", "День", "День"],
  Week: ["Viikko", "Неделя", "Тиждень"],
  Month: ["Kuukausi", "Месяц", "Місяць"],
  Dimension: ["Ulottuvuus", "Измерение", "Вимір"],
  Measure: ["Mittari", "Показатель", "Показник"],
  String: ["Teksti", "Текст", "Текст"],
  Boolean: ["Totuusarvo", "Логическое значение", "Логічне значення"],
  Date: ["Päivämäärä", "Дата", "Дата"],
  Timestamp: ["Aikaleima", "Временная метка", "Часова позначка"],
  Array: ["Taulukkoarvo", "Массив", "Масив"],
  Record: ["Tietue", "Запись", "Запис"],
  "Choose at least one available table column.": [
    "Valitse vähintään yksi saatavilla oleva taulukkosarake.",
    "Выберите хотя бы один доступный столбец таблицы.",
    "Виберіть хоча б один доступний стовпець таблиці.",
  ],
  "Use a table for nested results.": [
    "Käytä sisäkkäisille tuloksille taulukkoa.",
    "Используйте таблицу для вложенных результатов.",
    "Використовуйте таблицю для вкладених результатів.",
  ],
  "Choose numeric chart values from the query results.": [
    "Valitse kyselyn tuloksista numeeriset kaavioarvot.",
    "Выберите числовые значения диаграммы из результатов запроса.",
    "Виберіть числові значення діаграми з результатів запиту.",
  ],
  "A KPI requires exactly one numeric value.": [
    "KPI vaatii täsmälleen yhden numeerisen arvon.",
    "Для KPI требуется ровно одно числовое значение.",
    "Для KPI потрібне рівно одне числове значення.",
  ],
  "KPI requires one result row. Remove grouping or use a table.": [
    "KPI vaatii yhden tulosrivin. Poista ryhmittely tai käytä taulukkoa.",
    "Для KPI нужна одна строка. Уберите группировку или используйте таблицу.",
    "Для KPI потрібен один рядок. Приберіть групування або використовуйте таблицю.",
  ],
  "Choose an X-axis field from the query results.": [
    "Valitse kyselyn tuloksista X-akselin kenttä.",
    "Выберите поле оси X из результатов запроса.",
    "Виберіть поле осі X з результатів запиту.",
  ],
  "A pie chart requires one numeric value.": [
    "Ympyräkaavio vaatii yhden numeerisen arvon.",
    "Для круговой диаграммы нужно одно числовое значение.",
    "Для кругової діаграми потрібне одне числове значення.",
  ],
  "This report uses a source query.": [
    "Tämä raportti käyttää Malloy-kyselyä.",
    "Этот отчёт использует запрос Malloy.",
    "Цей звіт використовує запит Malloy.",
  ],
  "Choose a business source.": [
    "Valitse liiketoiminnan tietolähde.",
    "Выберите источник бизнес-данных.",
    "Виберіть джерело бізнес-даних.",
  ],
  "Choose at least one measure.": [
    "Valitse vähintään yksi mittari.",
    "Выберите хотя бы один показатель.",
    "Виберіть хоча б один показник.",
  ],
  "Row limit must be between 1 and 1,000.": [
    "Rivirajan on oltava 1–1 000.",
    "Ограничение строк должно быть от 1 до 1 000.",
    "Обмеження рядків має бути від 1 до 1 000.",
  ],
  "Choose measures for values and dimensions for grouping.": [
    "Valitse arvoiksi mittarit ja ryhmittelyyn ulottuvuudet.",
    "Выберите показатели для значений и измерения для группировки.",
    "Виберіть показники для значень і виміри для групування.",
  ],
  "Enter a filter value or remove the filter.": [
    "Anna suodatinarvo tai poista suodatin.",
    "Введите значение фильтра или удалите фильтр.",
    "Введіть значення фільтра або видаліть фільтр.",
  ],
  "Filters must use dimensions.": [
    "Suodattimissa on käytettävä ulottuvuuksia.",
    "Фильтры должны использовать измерения.",
    "Фільтри мають використовувати виміри.",
  ],
  "The data engine could not start. Reload the page to retry.": [
    "Tietomoottori ei käynnistynyt. Lataa sivu uudelleen.",
    "Не удалось запустить движок данных. Перезагрузите страницу.",
    "Не вдалося запустити рушій даних. Перезавантажте сторінку.",
  ],
  "The data engine took too long to start. Reload the page to retry.": [
    "Tietomoottorin käynnistys kesti liian kauan. Lataa sivu uudelleen.",
    "Запуск движка данных занял слишком много времени. Перезагрузите страницу.",
    "Запуск рушія даних тривав надто довго. Перезавантажте сторінку.",
  ],
  "Query context changed.": [
    "Kyselyn konteksti muuttui.",
    "Контекст запроса изменился.",
    "Контекст запиту змінився.",
  ],
  "The query exceeded five seconds. The data engine has been reset; try a smaller query.":
    [
      "Kysely ylitti viisi sekuntia. Tietomoottori nollattiin; kokeile pienempää kyselyä.",
      "Запрос превысил пять секунд. Движок сброшен; попробуйте меньший запрос.",
      "Запит перевищив п’ять секунд. Рушій скинуто; спробуйте менший запит.",
    ],
  "Query cancelled. The data engine is ready for another query.": [
    "Kysely peruutettu. Tietomoottori on valmis uuteen kyselyyn.",
    "Запрос отменён. Движок готов к новому запросу.",
    "Запит скасовано. Рушій готовий до нового запиту.",
  ],
  "Preparing the selected data…": [
    "Valmistellaan valittuja tietoja…",
    "Подготовка выбранных данных…",
    "Підготовка вибраних даних…",
  ],
  "The query engine is still initializing.": [
    "Kyselymoottoria alustetaan vielä.",
    "Движок запросов ещё инициализируется.",
    "Рушій запитів ще ініціалізується.",
  ],
  "Only the North Coast Operating Unit is available.": [
    "Vain North Coast -toimintayksikkö on saatavilla.",
    "Доступно только подразделение North Coast.",
    "Доступний лише операційний підрозділ North Coast.",
  ],
  "Only the bundled Luuta model can be imported.": [
    "Vain mukana toimitettu Luutan malli voidaan tuoda.",
    "Можно импортировать только встроенную модель Luuta.",
    "Можна імпортувати лише вбудовану модель Luuta.",
  ],
  "Invalid reporting period.": [
    "Virheellinen raportointijakso.",
    "Некорректный отчётный период.",
    "Некоректний звітний період.",
  ],
  "Unable to run this query.": [
    "Kyselyä ei voitu suorittaa.",
    "Не удалось выполнить запрос.",
    "Не вдалося виконати запит.",
  ],
  "Technical details": [
    "Tekniset tiedot",
    "Технические сведения",
    "Технічні відомості",
  ],
  Find: ["Etsi", "Найти", "Знайти"],
  Replace: ["Korvaa", "Заменить", "Замінити"],
  "Replace all": ["Korvaa kaikki", "Заменить всё", "Замінити все"],
  "Next match": ["Seuraava osuma", "Следующее совпадение", "Наступний збіг"],
  "Previous match": [
    "Edellinen osuma",
    "Предыдущее совпадение",
    "Попередній збіг",
  ],
  All: ["Kaikki", "Все", "Усі"],
  "Match case": [
    "Kirjainkoko merkitsee",
    "Учитывать регистр",
    "Враховувати регістр",
  ],
  "By word": ["Kokonaiset sanat", "Целые слова", "Цілі слова"],
  Regexp: ["Säännöllinen lauseke", "Регулярное выражение", "Регулярний вираз"],
  close: ["sulje", "закрыть", "закрити"],
  Completions: [
    "Täydennysehdotukset",
    "Варианты дополнения",
    "Варіанти доповнення",
  ],
  "Fold line": ["Taita rivi", "Свернуть строку", "Згорнути рядок"],
  "Unfold line": ["Avaa rivi", "Развернуть строку", "Розгорнути рядок"],
  to: ["asti", "до", "до"],
  "Folded lines": ["Taitetut rivit", "Свёрнутые строки", "Згорнуті рядки"],
  "Go to line": ["Siirry riville", "Перейти к строке", "Перейти до рядка"],
  go: ["siirry", "перейти", "перейти"],
  "Control character": [
    "Ohjausmerkki",
    "Управляющий символ",
    "Керівний символ",
  ],
  "No diagnostics": ["Ei diagnostiikkaa", "Нет замечаний", "Немає зауважень"],
  Diagnostics: ["Diagnostiikka", "Замечания", "Зауваження"],
  "lint panel": [
    "diagnostiikkapaneeli",
    "панель замечаний",
    "панель зауважень",
  ],
  "Diagnostics are not available": [
    "Diagnostiikkaa ei ole saatavilla",
    "Замечания недоступны",
    "Зауваження недоступні",
  ],
  "Active property units at the fixed snapshot; historical period filters do not apply.":
    [
      "Aktiiviset kiinteistöyksiköt kiinteässä tilannekuvassa; historialliset suodattimet eivät vaikuta.",
      "Активные помещения на фиксированный момент; фильтры исторического периода не применяются.",
      "Активні приміщення на фіксований момент; фільтри історичного періоду не застосовуються.",
    ],
  "Per-employee cleaning session spans; recorded time includes breaks.": [
    "Työntekijäkohtaiset siivoustyöjaksot; kirjattu aika sisältää tauot.",
    "Интервалы уборки каждого сотрудника; учтённое время включает перерывы.",
    "Інтервали прибирання кожного працівника; облікований час включає перерви.",
  ],
  "Inspection tasks with optional results; first failure remains visible after reinspection.":
    [
      "Tarkastustehtävät mahdollisine tuloksineen; ensimmäinen hylkäys näkyy uusintatarkastuksen jälkeenkin.",
      "Задачи проверок с необязательными результатами; первая неудача видна и после повторной проверки.",
      "Завдання перевірок із необов’язковими результатами; перша невдача видима й після повторної перевірки.",
    ],
  "Supply-order status and age; order age is not cleaner waiting time.": [
    "Tarviketilausten tila ja ikä; tilauksen ikä ei ole siivoojan odotusaikaa.",
    "Статус и возраст заказов материалов; возраст заказа не является временем ожидания уборщика.",
    "Статус і вік замовлень матеріалів; вік замовлення не є часом очікування прибиральника.",
  ],
  "Task-cohort analytics with recorded effort, task deadlines and first-inspection evidence.":
    [
      "Tehtäväjoukon analytiikka: kirjattu työaika, määräajat ja ensitarkastuksen tiedot.",
      "Аналитика выборки задач: учтённые трудозатраты, сроки и данные первой проверки.",
      "Аналітика вибірки завдань: обліковані трудовитрати, строки й дані першої перевірки.",
    ],
  "One (CleaningTask.id, employeeId)": [
    "Yksi (CleaningTask.id, employeeId)",
    "Одна пара (CleaningTask.id, employeeId)",
    "Одна пара (CleaningTask.id, employeeId)",
  ],
  "One CleaningTask.id": [
    "Yksi CleaningTask.id",
    "Одна запись CleaningTask.id",
    "Один запис CleaningTask.id",
  ],
  "One InspectorTask.id with optional result": [
    "Yksi InspectorTask.id mahdollisine tuloksineen",
    "Одна запись InspectorTask.id с необязательным результатом",
    "Один запис InspectorTask.id із необов’язковим результатом",
  ],
  "One SupplyOrder.id": [
    "Yksi SupplyOrder.id",
    "Одна запись SupplyOrder.id",
    "Один запис SupplyOrder.id",
  ],
  "One active PropertyUnit.id at as-of": [
    "Yksi aktiivinen PropertyUnit.id tilannekuvassa",
    "Одна активная запись PropertyUnit.id на момент снимка",
    "Один активний запис PropertyUnit.id на момент знімка",
  ],
  "JSON-encoded composite key": [
    "JSON-koodattu yhdistelmäavain",
    "Составной ключ в JSON",
    "Складений ключ у JSON",
  ],
  "Owning task": ["Omistava tehtävä", "Связанная задача", "Пов’язане завдання"],
  "CLEAN / DIRTY / IN_PROGRESS / INSPECTION": [
    "Puhdas / likainen / työn alla / tarkastus",
    "Чисто / грязно / в работе / проверка",
    "Чисто / брудно / у роботі / перевірка",
  ],
  "submitted / fulfilled / cancelled": [
    "lähetetty / toimitettu / peruutettu",
    "отправлен / выполнен / отменён",
    "надіслано / виконано / скасовано",
  ],
  Id: ["Tunniste", "Идентификатор", "Ідентифікатор"],
  "Task id": ["Tehtävän tunniste", "ID задачи", "ID завдання"],
  "Unit id": ["Yksikön tunniste", "ID помещения", "ID приміщення"],
  "Unit name": ["Yksikön nimi", "Название помещения", "Назва приміщення"],
  "Unit type": ["Yksikön tyyppi", "Тип помещения", "Тип приміщення"],
  "Operating unit id": [
    "Toimintayksikön tunniste",
    "ID подразделения",
    "ID підрозділу",
  ],
  "Property id": ["Kiinteistön tunniste", "ID объекта", "ID об’єкта"],
  "Property name": ["Kiinteistön nimi", "Название объекта", "Назва об’єкта"],
  "Employee id": ["Työntekijän tunniste", "ID сотрудника", "ID працівника"],
  "Employee name": ["Työntekijän nimi", "Имя сотрудника", "Ім’я працівника"],
  "Assignment id": ["Tehtäväjaon tunniste", "ID назначения", "ID призначення"],
  "Session key": ["Työjakson avain", "Ключ сессии", "Ключ сесії"],
  "Result id": ["Tuloksen tunniste", "ID результата", "ID результату"],
  "Source result id": [
    "Lähdetuloksen tunniste",
    "ID исходного результата",
    "ID вихідного результату",
  ],
  "Shift id": ["Työvuoron tunniste", "ID смены", "ID зміни"],
  "Request id": ["Pyynnön tunniste", "ID заявки", "ID заявки"],
  "Snapshot at": ["Tilannekuvan aika", "Время снимка", "Час знімка"],
  "Started at": ["Aloitusaika", "Время начала", "Час початку"],
  "Ended at": ["Päättymisaika", "Время окончания", "Час закінчення"],
  "Completed at": ["Valmistumisaika", "Время завершения", "Час завершення"],
  "Created at": ["Luontiaika", "Время создания", "Час створення"],
  "Submitted at": ["Lähetysaika", "Время отправки", "Час надсилання"],
  "State changed at": [
    "Tilan muutosaika",
    "Время изменения статуса",
    "Час зміни статусу",
  ],
  Deadline: ["Määräaika", "Срок", "Строк"],
  Status: ["Tila", "Статус", "Статус"],
  "Cleaning state": ["Siivoustila", "Состояние уборки", "Стан прибирання"],
  "Supply state": ["Tarviketila", "Статус материалов", "Статус матеріалів"],
  Outcome: ["Tulos", "Результат", "Результат"],
  Rating: ["Arvio", "Оценка", "Оцінка"],
  Priority: ["Kiireellisyys", "Приоритет", "Пріоритет"],
  Participants: ["Osallistujat", "Участники", "Учасники"],
  "Participant count": [
    "Osallistujien määrä",
    "Число участников",
    "Кількість учасників",
  ],
  Completed: ["Valmis", "Завершено", "Завершено"],
  Due: ["Erääntynyt", "Срок наступил", "Строк настав"],
  "On time": ["Ajoissa", "Вовремя", "Вчасно"],
  "Has inspection": ["Tarkastus tehty", "Есть проверка", "Є перевірка"],
  "First inspection": ["Ensitarkastus", "Первая проверка", "Перша перевірка"],
  "First outcome": [
    "Ensimmäinen tulos",
    "Первый результат",
    "Перший результат",
  ],
  "First pass": ["Ensimmäinen hyväksyntä", "Первый успех", "Перший успіх"],
  "Open session": ["Avoin työjakso", "Открытая сессия", "Відкрита сесія"],
  "Open session count": [
    "Avoimien työjaksojen määrä",
    "Число открытых сессий",
    "Кількість відкритих сесій",
  ],
  "Invalid completion": [
    "Virheellinen valmistuminen",
    "Некорректное завершение",
    "Некоректне завершення",
  ],
  "Invalid timestamp": [
    "Virheellinen aikaleima",
    "Некорректная временная метка",
    "Некоректна часова позначка",
  ],
  "Invalid session count": [
    "Virheellisten työjaksojen määrä",
    "Число некорректных сессий",
    "Кількість некоректних сесій",
  ],
  "Invalid break count": [
    "Virheellisten taukojen määrä",
    "Число некорректных перерывов",
    "Кількість некоректних перерв",
  ],
  "Recorded minutes": [
    "Kirjatut minuutit",
    "Учтённые минуты",
    "Обліковані хвилини",
  ],
  "Break minutes": ["Taukominuutit", "Минуты перерывов", "Хвилини перерв"],
  "Coffee minutes": [
    "Kahvitaukominuutit",
    "Минуты кофе-перерывов",
    "Хвилини кавових перерв",
  ],
  "Meal minutes": ["Ruokataukominuutit", "Минуты обеда", "Хвилини обіду"],
  "Elapsed minutes": [
    "Kuluneet minuutit",
    "Прошедшие минуты",
    "Хвилини, що минули",
  ],
  "Observed minutes": [
    "Havaitut minuutit",
    "Наблюдаемые минуты",
    "Спостережувані хвилини",
  ],
  "Age minutes": ["Ikä minuutteina", "Возраст в минутах", "Вік у хвилинах"],
  "Oldest order minutes": [
    "Vanhin tilaus minuutteina",
    "Старейший заказ в минутах",
    "Найстаріше замовлення у хвилинах",
  ],
  "Submitted orders": [
    "Lähetetyt tilaukset",
    "Отправленные заказы",
    "Надіслані замовлення",
  ],
  Sessions: ["Työjaksot", "Сессии", "Сесії"],
  "Observed session span": [
    "Havaittu työjakson pituus",
    "Наблюдаемый интервал сессии",
    "Спостережуваний інтервал сесії",
  ],
  "Observed break time": [
    "Havaittu taukoaika",
    "Наблюдаемое время перерывов",
    "Спостережуваний час перерв",
  ],
  "Coffee breaks": ["Kahvitauot", "Кофе-перерывы", "Кавові перерви"],
  "Meal breaks": ["Ruokatauot", "Обеденные перерывы", "Обідні перерви"],
  "Open sessions": ["Avoimet työjaksot", "Открытые сессии", "Відкриті сесії"],
  "Invalid session timestamps": [
    "Virheelliset työjaksojen aikaleimat",
    "Некорректные временные метки сессий",
    "Некоректні часові позначки сесій",
  ],
  "Inspection tasks": [
    "Tarkastustehtävät",
    "Задачи проверок",
    "Завдання перевірок",
  ],
  "Submitted results": [
    "Lähetetyt tulokset",
    "Сданные результаты",
    "Здані результати",
  ],
  "First submitted inspections": [
    "Ensimmäiset lähetetyt tarkastukset",
    "Первые сданные проверки",
    "Перші здані перевірки",
  ],
  "First CLEAN outcomes": [
    "Ensimmäiset puhtaat tulokset",
    "Первые результаты «Чисто»",
    "Перші результати «Чисто»",
  ],
  "Oldest submitted order": [
    "Vanhin lähetetty tilaus",
    "Старейший отправленный заказ",
    "Найстаріше надіслане замовлення",
  ],
  "Completed tasks": [
    "Valmistuneet tehtävät",
    "Завершённые задачи",
    "Завершені завдання",
  ],
  "Tasks due": [
    "Erääntyneet tehtävät",
    "Задачи с наступившим сроком",
    "Завдання зі строком, що настав",
  ],
  "Completed by deadline": [
    "Valmis määräajassa",
    "Завершено в срок",
    "Завершено вчасно",
  ],
  "Cleaning completed by deadline": [
    "Siivous valmis määräajassa",
    "Уборка завершена в срок",
    "Прибирання завершено вчасно",
  ],
  "Non-cancelled tasks": [
    "Peruuttamattomat tehtävät",
    "Неотменённые задачи",
    "Нескасовані завдання",
  ],
  "Inspected tasks": [
    "Tarkastetut tehtävät",
    "Проверенные задачи",
    "Перевірені завдання",
  ],
  "First inspected tasks": [
    "Ensitarkastetut tehtävät",
    "Задачи с первой проверкой",
    "Завдання з першою перевіркою",
  ],
  "First failures": [
    "Ensimmäiset hylkäykset",
    "Первые неудачи",
    "Перші невдачі",
  ],
  "Missing/invalid completions": [
    "Puuttuvat tai virheelliset valmistumiset",
    "Отсутствующие/некорректные завершения",
    "Відсутні/некоректні завершення",
  ],
  "Tasks with submitted orders": [
    "Tehtävät, joilla on lähetetty tilaus",
    "Задачи с отправленными заказами",
    "Завдання з надісланими замовленнями",
  ],
  "Active units": [
    "Aktiiviset yksiköt",
    "Активные помещения",
    "Активні приміщення",
  ],
  "By employee": ["Työntekijöittäin", "По сотрудникам", "За працівниками"],
  "By property": ["Kiinteistöittäin", "По объектам", "За об’єктами"],
  "State distribution": [
    "Tilojen jakauma",
    "Распределение статусов",
    "Розподіл статусів",
  ],
  "Daily completion": [
    "Päivittäinen valmistuminen",
    "Завершение по дням",
    "Завершення за днями",
  ],
  Outcomes: ["Tulokset", "Результаты", "Результати"],
  "Actual break minutes": [
    "Todelliset taukominuutit",
    "Фактические минуты перерывов",
    "Фактичні хвилини перерв",
  ],
  "Actual coffee minutes": [
    "Todelliset kahvitaukominuutit",
    "Фактические минуты кофе-перерывов",
    "Фактичні хвилини кавових перерв",
  ],
  "Actual meal minutes": [
    "Todelliset ruokataukominuutit",
    "Фактические минуты обеда",
    "Фактичні хвилини обіду",
  ],
  "Additional trips": [
    "Lisäajot",
    "Дополнительные поездки",
    "Додаткові поїздки",
  ],
  "Allocated euros": [
    "Kohdistetut eurot",
    "Распределённые евро",
    "Розподілені євро",
  ],
  "Available weight": [
    "Saatavilla oleva paino",
    "Доступный вес",
    "Доступна вага",
  ],
  "Clean unit count": [
    "Puhtaiden yksiköiden määrä",
    "Число чистых помещений",
    "Кількість чистих приміщень",
  ],
  "Cleaner comparison": [
    "Siivoojien vertailu",
    "Сравнение уборщиков",
    "Порівняння прибиральників",
  ],
  "Cleaner waiting": [
    "Siivoojien odotus",
    "Ожидание уборщиков",
    "Очікування прибиральників",
  ],
  "Completed task count": [
    "Valmistuneiden tehtävien määrä",
    "Число завершённых задач",
    "Кількість завершених завдань",
  ],
  Components: ["Osatekijät", "Компоненты", "Компоненти"],
  Contribution: ["Kate", "Маржинальный доход", "Маржинальний дохід"],
  "Currently clean pct": [
    "Puhtaiden osuus (%)",
    "Доля чистых (%)",
    "Частка чистих (%)",
  ],
  "Daily finances": [
    "Päivittäiset taloustiedot",
    "Финансы по дням",
    "Фінанси за днями",
  ],
  "Daily score": [
    "Päivittäinen pistemäärä",
    "Оценка по дням",
    "Оцінка за днями",
  ],
  Deliveries: ["Toimitukset", "Доставки", "Доставки"],
  "Deliveries by driver": [
    "Toimitukset kuljettajittain",
    "Доставки по водителям",
    "Доставки за водіями",
  ],
  "Dog help": ["Koira / lisäapu", "Собаки/помощь", "Собаки/допомога"],
  "Dog help deliveries": [
    "Koira- ja lisäaputoimitukset",
    "Доставки с собаками/помощью",
    "Доставки із собаками/допомогою",
  ],
  "Dog help share": [
    "Koira- ja lisäaputoimitusten osuus",
    "Доля доставок с собаками/помощью",
    "Частка доставок із собаками/допомогою",
  ],
  Drivers: ["Kuljettajat", "Водители", "Водії"],
  "Due deliveries": [
    "Erääntyneet toimitukset",
    "Доставки с наступившим сроком",
    "Доставки зі строком, що настав",
  ],
  "Due task count": [
    "Erääntyneiden tehtävien määrä",
    "Число задач с наступившим сроком",
    "Кількість завдань зі строком, що настав",
  ],
  "Eligible shifts": [
    "Kelvolliset työvuorot",
    "Учтённые смены",
    "Враховані зміни",
  ],
  "Eligible task count": [
    "Kelvollisten tehtävien määrä",
    "Число учитываемых задач",
    "Кількість врахованих завдань",
  ],
  "First clean count": [
    "Ensimmäisten puhtaiden määrä",
    "Число первых результатов «Чисто»",
    "Кількість перших результатів «Чисто»",
  ],
  "First failure count": [
    "Ensimmäisten hylkäysten määrä",
    "Число первых неудач",
    "Кількість перших невдач",
  ],
  "First inspection quality pct": [
    "Ensitarkastuksen laatu (%)",
    "Качество первой проверки (%)",
    "Якість першої перевірки (%)",
  ],
  "First result count": [
    "Ensimmäisten tulosten määrä",
    "Число первых результатов",
    "Кількість перших результатів",
  ],
  "Hourly wage": ["Tuntipalkka", "Почасовая ставка", "Погодинна ставка"],
  "Inspected task count": [
    "Tarkastettujen tehtävien määrä",
    "Число проверенных задач",
    "Кількість перевірених завдань",
  ],
  "Inspection coverage pct": [
    "Tarkastusten kattavuus (%)",
    "Охват проверками (%)",
    "Охоплення перевірками (%)",
  ],
  "Inspection task count": [
    "Tarkastustehtävien määrä",
    "Число задач проверок",
    "Кількість завдань перевірок",
  ],
  "Invalid breaks": [
    "Virheelliset tauot",
    "Некорректные перерывы",
    "Некоректні перерви",
  ],
  "Invalid completions": [
    "Virheelliset valmistumiset",
    "Некорректные завершения",
    "Некоректні завершення",
  ],
  "Invalid sessions": [
    "Virheelliset työjaksot",
    "Некорректные сессии",
    "Некоректні сесії",
  ],
  "Lunch minutes": ["Lounasminuutit", "Минуты обеда", "Хвилини обіду"],
  "Missing evidence": [
    "Puuttuvat tiedot",
    "Недостающие данные",
    "Відсутні дані",
  ],
  "Missing evidence shifts": [
    "Vuorot, joista puuttuu tietoja",
    "Смены с неполными данными",
    "Зміни з неповними даними",
  ],
  "Observed person hours": [
    "Havaitut henkilötyötunnit",
    "Наблюдаемые человеко-часы",
    "Спостережувані людино-години",
  ],
  "Oldest submitted order minutes": [
    "Vanhimman lähetetyn tilauksen minuutit",
    "Минуты старейшего отправленного заказа",
    "Хвилини найстарішого надісланого замовлення",
  ],
  "On time completion pct": [
    "Ajoissa valmistuneiden osuus (%)",
    "Завершение вовремя (%)",
    "Завершення вчасно (%)",
  ],
  "On time deliveries": [
    "Ajoissa tehdyt toimitukset",
    "Доставки вовремя",
    "Доставки вчасно",
  ],
  "On time task count": [
    "Ajoissa valmistuneiden tehtävien määrä",
    "Число задач, завершённых вовремя",
    "Кількість завдань, завершених вчасно",
  ],
  "Order count": ["Tilausten määrä", "Число заказов", "Кількість замовлень"],
  "Paid coffee minutes": [
    "Palkalliset kahvitaukominuutit",
    "Оплаченные минуты кофе-перерывов",
    "Оплачені хвилини кавових перерв",
  ],
  "Paid minutes": [
    "Palkalliset minuutit",
    "Оплаченные минуты",
    "Оплачені хвилини",
  ],
  "Paid task time": [
    "Palkallinen tehtäväaika",
    "Оплаченное время задач",
    "Оплачений час завдань",
  ],
  "Payroll evidence": ["Palkkatiedot", "Данные оплаты", "Дані оплати"],
  "Productivity ratio": [
    "Tuottavuussuhde",
    "Коэффициент производительности",
    "Коефіцієнт продуктивності",
  ],
  "Productivity target": [
    "Tuottavuustavoite",
    "Цель производительности",
    "Ціль продуктивності",
  ],
  "Recorded person hours": [
    "Kirjatut henkilötyötunnit",
    "Учтённые человеко-часы",
    "Обліковані людино-години",
  ],
  "Repeat component": [
    "Uusintojen osatekijä",
    "Компонент повторов",
    "Компонент повторів",
  ],
  "Repeat weight": ["Uusintojen paino", "Вес повторов", "Вага повторів"],
  "Request count": ["Pyyntöjen määrä", "Число заявок", "Кількість заявок"],
  Revenue: ["Tulot", "Доход", "Дохід"],
  "Session count": ["Työjaksojen määrä", "Число сессий", "Кількість сесій"],
  "Shift detail": [
    "Työvuoron tiedot",
    "Сведения о смене",
    "Відомості про зміну",
  ],
  "Sla compliance": [
    "SLA-vaatimusten täyttyminen",
    "Соблюдение SLA",
    "Дотримання SLA",
  ],
  "Sla weight": ["SLA-paino", "Вес SLA", "Вага SLA"],
  "Submitted order count": [
    "Lähetettyjen tilausten määrä",
    "Число отправленных заказов",
    "Кількість надісланих замовлень",
  ],
  "Submitted result count": [
    "Lähetettyjen tulosten määrä",
    "Число сданных результатов",
    "Кількість зданих результатів",
  ],
  Summary: ["Yhteenveto", "Сводка", "Зведення"],
  "Task count": ["Tehtävien määrä", "Число задач", "Кількість завдань"],
  Tasks: ["Tehtävät", "Задачи", "Завдання"],
  "Teho score": ["TEHO-pistemäärä", "Оценка TEHO", "Оцінка TEHO"],
  "Trip count": ["Ajojen määrä", "Число поездок", "Кількість поїздок"],
  "Trip detail": ["Ajon tiedot", "Сведения о поездке", "Відомості про поїздку"],
  "Trip km": ["Ajokilometrit", "Километры поездки", "Кілометри поїздки"],
  Trips: ["Ajot", "Поездки", "Поїздки"],
  "Unit count": ["Yksiköiden määrä", "Число помещений", "Кількість приміщень"],
  "Urgent due": [
    "Erääntyneet kiireelliset",
    "Срочные с наступившим сроком",
    "Термінові зі строком, що настав",
  ],
  "Urgent handling": [
    "Kiireellisten käsittely",
    "Обработка срочных заявок",
    "Обробка термінових заявок",
  ],
  "Urgent on time": [
    "Kiireelliset ajoissa",
    "Срочные вовремя",
    "Термінові вчасно",
  ],
  "Wage euros": ["Palkka euroina", "Оплата в евро", "Оплата в євро"],
  Wages: ["Palkat", "Оплата", "Оплата"],
  Waiting: ["Odotus", "Ожидание", "Очікування"],
  "Waiting budget minutes": [
    "Odotusbudjetti minuutteina",
    "Бюджет ожидания в минутах",
    "Бюджет очікування у хвилинах",
  ],
  "Waiting minutes": [
    "Odotusminuutit",
    "Минуты ожидания",
    "Хвилини очікування",
  ],
  "Waiting per request": [
    "Odotus pyyntöä kohti",
    "Ожидание на заявку",
    "Очікування на заявку",
  ],
  Weights: ["Painot", "Веса", "Ваги"],
  "Workload credit": [
    "Työmääräpiste",
    "Кредит нагрузки",
    "Кредит навантаження",
  ],
  "Workload credits": [
    "Työmääräpisteet",
    "Кредиты нагрузки",
    "Кредити навантаження",
  ],
  "Active productivity weight": [
    "Tuottavuuden aktiivinen paino",
    "Активный вес производительности",
    "Активна вага продуктивності",
  ],
  "Active repeat weight": [
    "Uusintojen aktiivinen paino",
    "Активный вес повторов",
    "Активна вага повторів",
  ],
  "Active route weight": [
    "Reitin aktiivinen paino",
    "Активный вес маршрута",
    "Активна вага маршруту",
  ],
  "Active sla weight": [
    "Aktiivinen SLA-paino",
    "Активный вес SLA",
    "Активна вага SLA",
  ],
  "Active urgent weight": [
    "Kiireellisyyden aktiivinen paino",
    "Активный вес срочности",
    "Активна вага терміновості",
  ],
  "Active waiting weight": [
    "Odotuksen aktiivinen paino",
    "Активный вес ожидания",
    "Активна вага очікування",
  ],
  "Productivity base weight": [
    "Tuottavuuden peruspaino",
    "Базовый вес производительности",
    "Базова вага продуктивності",
  ],
  "Repeat base weight": [
    "Uusintojen peruspaino",
    "Базовый вес повторов",
    "Базова вага повторів",
  ],
  "Route base weight": [
    "Reitin peruspaino",
    "Базовый вес маршрута",
    "Базова вага маршруту",
  ],
  "Sla base weight": ["SLA-peruspaino", "Базовый вес SLA", "Базова вага SLA"],
  "Urgent base weight": [
    "Kiireellisyyden peruspaino",
    "Базовый вес срочности",
    "Базова вага терміновості",
  ],
  "Waiting base weight": [
    "Odotuksen peruspaino",
    "Базовый вес ожидания",
    "Базова вага очікування",
  ],
  Clean: ["Puhdas", "Чисто", "Чисто"],
  Dirty: ["Likainen", "Грязно", "Брудно"],
  "In progress": ["Työn alla", "В работе", "У роботі"],
  Cancelled: ["Peruutettu", "Отменено", "Скасовано"],
  Submitted: ["Lähetetty", "Отправлено", "Надіслано"],
  Fulfilled: ["Toimitettu", "Выполнено", "Виконано"],
  Pending: ["Odottaa", "Ожидает", "Очікує"],
  Scheduled: ["Ajoitettu", "Запланировано", "Заплановано"],
  Started: ["Aloitettu", "Начато", "Розпочато"],
  Paused: ["Keskeytetty", "Приостановлено", "Призупинено"],
  Failed: ["Hylätty", "Не пройдено", "Не пройдено"],
  Passed: ["Hyväksytty", "Пройдено", "Пройдено"],
  Normal: ["Normaali", "Обычный", "Звичайний"],
  High: ["Korkea", "Высокий", "Високий"],
  Low: ["Matala", "Низкий", "Низький"],
  Direction: ["Suunta", "Направление", "Напрямок"],
  "Actual km": [
    "Todelliset kilometrit",
    "Фактические километры",
    "Фактичні кілометри",
  ],
  "Attempt number": ["Yrityksen numero", "Номер попытки", "Номер спроби"],
  "Cleaner id": ["Siivoojan tunniste", "ID уборщика", "ID прибиральника"],
  Closed: ["Päättynyt", "Закрыто", "Закрито"],
  Eligible: ["Kelvollinen", "Учитывается", "Враховується"],
  "Evidence complete": ["Tiedot täydelliset", "Данные полны", "Дані повні"],
  "Hourly rate cents": [
    "Tuntihinta sentteinä",
    "Почасовая ставка в центах",
    "Погодинна ставка в центах",
  ],
  Kilometres: ["Kilometrit", "Километры", "Кілометри"],
  "Planned km": [
    "Suunnitellut kilometrit",
    "Плановые километры",
    "Планові кілометри",
  ],
  "Price cents": ["Hinta sentteinä", "Цена в центах", "Ціна в центах"],
  "Prior paid task minutes": [
    "Aiemmat palkalliset tehtäväminuutit",
    "Предшествующие оплаченные минуты задач",
    "Попередні оплачені хвилини завдань",
  ],
  "Total paid task minutes": [
    "Palkalliset tehtäväminuutit yhteensä",
    "Всего оплаченных минут задач",
    "Усього оплачених хвилин завдань",
  ],
  "Wait minutes": ["Odotusminuutit", "Минуты ожидания", "Хвилини очікування"],
  "Use Cleaner sessions for employee comparisons. Task totals and quality cannot be assigned to each employee.":
    [
      "Käytä siivoojien työjaksoja työntekijävertailuun. Tehtävien kokonaismääriä ja laatua ei voi kohdistaa jokaiselle työntekijälle.",
      "Для сравнения сотрудников используйте сессии уборщиков. Итоги и качество задач нельзя присваивать каждому сотруднику.",
      "Для порівняння працівників використовуйте сесії прибиральників. Підсумки та якість завдань не можна приписувати кожному працівнику.",
    ],
  "Unknown field: {field}": [
    "Tuntematon kenttä: {field}",
    "Неизвестное поле: {field}",
    "Невідоме поле: {field}",
  ],
  "The data engine failed. Retry the report on the restarted engine.": [
    "Tietomoottori epäonnistui. Yritä raporttia uudelleen käynnistetyllä moottorilla.",
    "Сбой движка данных. Повторите отчёт на перезапущенном движке.",
    "Збій рушія даних. Повторіть звіт на перезапущеному рушії.",
  ],
  "The query engine did not initialize.": [
    "Kyselymoottori ei alustunut.",
    "Движок запросов не инициализирован.",
    "Рушій запитів не ініціалізовано.",
  ],
  "Task inspections": [
    "Tehtävien tarkastukset",
    "Проверки задач",
    "Перевірки завдань",
  ],
  Orders: ["Tilaukset", "Заказы", "Замовлення"],
  Allocations: ["Kohdistukset", "Распределения", "Розподіли"],
  "Priced task": ["Hinnoiteltu tehtävä", "Задача с ценой", "Завдання з ціною"],
  Requests: ["Pyynnöt", "Заявки", "Заявки"],
  Waits: ["Odotukset", "Ожидания", "Очікування"],
  "cleaning tasks": [
    "siivoustehtävät",
    "задачи по уборке",
    "завдання з прибирання",
  ],
  "current units": [
    "nykyiset yksiköt",
    "текущие помещения",
    "поточні приміщення",
  ],
  "cleaner sessions": [
    "siivoojien työjaksot",
    "сессии уборщиков",
    "сесії прибиральників",
  ],
  inspections: ["tarkastukset", "проверки", "перевірки"],
  "supply orders": [
    "tarviketilaukset",
    "заказы материалов",
    "замовлення матеріалів",
  ],
  bar: ["pylväs", "столбчатая", "стовпчаста"],
  line: ["viiva", "линейная", "лінійна"],
  pie: ["ympyrä", "круговая", "кругова"],
  kpi: ["KPI", "KPI", "KPI"],
  table: ["taulukko", "таблица", "таблиця"],
  nested: ["sisäkkäinen", "вложенный", "вкладений"],
  "cleaner-teho": ["siivoojan TEHO", "TEHO уборщика", "TEHO прибиральника"],
  "driver-teho": ["kuljettajan TEHO", "TEHO водителя", "TEHO водія"],
  Active: ["Aktiivinen", "Активно", "Активно"],
  Reviewed: ["Tarkastettu", "Проверено", "Перевірено"],
  Sent: ["Lähetetty", "Отправлено", "Надіслано"],
  Stocked: ["Varastossa", "В наличии", "У наявності"],
  Regular: ["Tavallinen", "Обычный", "Звичайний"],
  "Press Space to pick up a widget. Use the arrow keys to move it, Space to drop, or Escape to cancel.":
    [
      "Valitse osio painamalla välilyöntiä. Siirrä nuolinäppäimillä, pudota välilyönnillä tai peruuta Esc-näppäimellä.",
      "Нажмите пробел, чтобы взять виджет. Перемещайте стрелками, отпустите пробелом или отмените клавишей Escape.",
      "Натисніть пробіл, щоб узяти віджет. Переміщуйте стрілками, відпустіть пробілом або скасуйте клавішею Escape.",
    ],
  "Widget picked up.": ["Osio valittu.", "Виджет взят.", "Віджет узято."],
  "Widget moved to position {position}.": [
    "Osio siirretty kohtaan {position}.",
    "Виджет перемещён на позицию {position}.",
    "Віджет переміщено на позицію {position}.",
  ],
  "Widget dropped.": [
    "Osio pudotettu.",
    "Виджет размещён.",
    "Віджет розміщено.",
  ],
  "Reordering cancelled.": [
    "Järjestäminen peruutettu.",
    "Изменение порядка отменено.",
    "Зміну порядку скасовано.",
  ],
  "Folded lines from $ to $": [
    "Taitetut rivit $–$",
    "Свёрнутые строки с $ по $",
    "Згорнуті рядки від $ до $",
  ],
  "on line": ["rivillä", "в строке", "у рядку"],
  "No matches found": [
    "Osumia ei löytynyt",
    "Совпадения не найдены",
    "Збігів не знайдено",
  ],
  "replaced $ matches": [
    "korvattu $ osumaa",
    "заменено совпадений: $",
    "замінено збігів: $",
  ],
  "replaced match on line $": [
    "korvattu osuma rivillä $",
    "заменено совпадение в строке $",
    "замінено збіг у рядку $",
  ],
  "current match. $ matches": [
    "nykyinen osuma. $ osumaa",
    "текущее совпадение. Совпадений: $",
    "поточний збіг. Збігів: $",
  ],
  "match on line $": [
    "osuma rivillä $",
    "совпадение в строке $",
    "збіг у рядку $",
  ],
  "TEHO cleaner task allocations": [
    "TEHO-siivoojatehtävien kohdistukset",
    "Распределения задач уборщиков TEHO",
    "Розподіли завдань прибиральників TEHO",
  ],
  "Cleaner waiting evidence": [
    "Siivoojien odotustiedot",
    "Данные ожидания уборщиков",
    "Дані очікування прибиральників",
  ],
  "current match": ["nykyinen osuma", "текущее совпадение", "поточний збіг"],
  "folded code": ["taitettu koodi", "свёрнутый код", "згорнутий код"],
  unfold: ["avaa", "развернуть", "розгорнути"],
  "Selection deleted": [
    "Valinta poistettu",
    "Выделение удалено",
    "Виділення видалено",
  ],
  Statuses: ["Tilat", "Статусы", "Статуси"],
} as const satisfies Record<string, readonly [string, string, string]>;
export type MessageKey = keyof typeof messages;
